import React from "react";

export const WizardSide3 = ({ fillColor, fillContrast }) => {
  return (
    <svg
      height="314"
      viewBox="0 0 383 314"
      width="383"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <linearGradient
        id="a"
        x1="49.997253%"
        x2="49.997253%"
        y1="99.999504%"
        y2="0%"
      >
        <stop offset="0" stopColor="#808080" stopOpacity=".25" />
        <stop offset=".54" stopColor="#808080" stopOpacity=".12" />
        <stop offset="1" stopColor="#808080" stopOpacity=".1" />
      </linearGradient>
      <g fill="none" fillRule="evenodd" transform="translate(0 1)">
        <path
          d="m213.359897 99.677193h2.101603v116.107292h-2.101603z"
          fill="#afb6d4"
          fillRule="nonzero"
        />
        <path
          d="m217.449912 237.500954c-1.978892 1.540985-4.748503 1.540985-6.727395 0-.939495-6.212808 1.445089-18.422886 2.007277-21.175731l.116965-.552082h2.716615c.18072.179994.323189.39481.418811.631491 1.845034 3.981794 1.467727 21.096322 1.467727 21.096322z"
          fill="#535f89"
          fillRule="nonzero"
        />
        <path
          d="m214.993639 213.269867v2.507056h-1.131922v-2.507056c.182028-.030584.366301-.045763.550869-.045383.194573-.000181.388858.014991.581053.045383z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m215.96332 216.415976c-.477983.255612-1.012787.385705-1.554507.378138-.588281.014613-1.168393-.140249-1.671473-.446203l.116965-.552081h2.709069c.172688.178362.308595.389096.399946.620146z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <ellipse
          cx="214.408813"
          cy="215.005521"
          fill="#dce2ed"
          fillRule="nonzero"
          rx="2.267619"
          ry="1.349953"
        />
        <path
          d="m204.444119 80.9744847 7.983829-3.8305385 11.771997 2.8209099-9.134617-6.9199265z"
          fill={fillContrast}
          fillRule="nonzero"
        />
        <path
          d="m206.779653 82.1996521-2.335534-1.2251674 7.983829-3.8305385 11.771997 2.8209099-2.071419 1.0096286-9.700578-2.1818566z"
          fill={fillContrast}
          fillRule="nonzero"
        />
        <path
          d="m206.779653 82.1996521-2.335534-1.2251674 7.983829-3.8305385 11.771997 2.8209099-2.071419 1.0096286-9.700578-2.1818566z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m206.462715 81.2959021 6.425548 18.0447483h3.184476l5.950141-19.164037-9.594932-2.2347959z"
          fill="#dadff6"
          fillRule="nonzero"
          opacity=".2"
        />
        <path
          d="m217.649885 94.2622563-1.267754 4.0914538-.309392.9869403h-3.184476l-.237704-.6693043-1.501684-4.2162394 2.410996-1.4520502z"
          fill={fillContrast}
          fillRule="nonzero"
        />
        <path
          d="m212.427948 78.7926281 1.520549 20.5480223h-1.060234l-6.10861-17.1409983z"
          fill={fillColor}
          fillRule="nonzero"
          opacity=".2"
        />
        <path
          d="m215.065328 73.0449296-2.63738 4.0990166-7.983829 3.8305385z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m216.382131 98.3537101-.305619.9869403h-3.188249l-.237704-.6693043c.543105-.5324506 1.286981-.8075477 2.045007-.7562762.592724-.0206812 1.178672.1317115 1.686565.4386402z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m214.993639 99.6771933v1.7583417c-.0981 0-.1962 0-.298073 0-.282146.001281-.563407-.031732-.837622-.098316v-1.6600257z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <ellipse
          cx="214.691793"
          cy="99.677193"
          fill="#dce2ed"
          fillRule="nonzero"
          rx="2.267619"
          ry="1.349953"
        />
        <path
          d="m295.74501 156.148332h1.388492v76.762027h-1.388492z"
          fill="#afb6d4"
          fillRule="nonzero"
        />
        <path
          d="m298.454079 247.268261c-1.307435 1.018069-3.137249 1.018069-4.444684 0-.622557-4.10658.954589-12.183609 1.32435-13.991109.04905-.238227.079235-.378138.079235-.378138h1.777118c.119867.11856.214806.259997.279208.415952 1.230023 2.643185.984773 13.953295.984773 13.953295z"
          fill="#535f89"
          fillRule="nonzero"
        />
        <path
          d="m296.82411 231.250332v1.660026h-.754615v-1.660026c.124439-.022735.250844-.032869.377307-.030251.126348.000606.252472.010718.377308.030251z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m297.469306 233.311185c-.317942.165219-.671966.248396-1.03005.242008-.388434.008576-.77147-.092307-1.105511-.291166.04905-.238227.079235-.378138.079235-.378138h1.777118c.121136.121888.216148.267293.279208.427296z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <ellipse
          cx="296.439256"
          cy="232.396091"
          fill="#dce2ed"
          fillRule="nonzero"
          rx="1.497911"
          ry="1"
        />
        <path
          d="m289.851466 143.783217 5.278533-2.533525 7.783856 1.868002-6.040695-4.575471z"
          fill={fillContrast}
          fillRule="nonzero"
        />
        <path
          d="m291.394654 144.592432-1.543188-.809215 5.278533-2.533525 7.783856 1.868002-1.369627.665523-6.414229-1.440706z"
          fill={fillContrast}
          fillRule="nonzero"
        />
        <path
          d="m291.394654 144.592432-1.543188-.809215 5.278533-2.533525 7.783856 1.868002-1.369627.665523-6.414229-1.440706z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m291.183362 143.994974 4.248483 11.930256h2.109149l3.931546-12.667625-6.342541-1.47852z"
          fill="#dadff6"
          fillRule="nonzero"
          opacity=".2"
        />
        <path
          d="m298.582363 152.567364-.837622 2.707469-.203747.654179h-2.109149l-.154696-.442422-.992319-2.786878 1.592238-.96047z"
          fill={fillContrast}
          fillRule="nonzero"
        />
        <path
          d="m295.129999 142.342511 1.007411 13.582719h-.705565l-4.037191-11.332798z"
          fill={fillColor}
          fillRule="nonzero"
          opacity=".2"
        />
        <path
          d="m296.87316 138.542223-1.743161 2.707469-5.278533 2.533525z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m297.744741 155.274833-.203747.650397h-2.105376l-.158469-.442421c.357765-.353889.849068-.538189 1.350761-.506705.393348-.011441.781482.092377 1.116831.298729z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m296.82411 156.148332v1.157102h-.1962c-.185527.00072-.37047-.020862-.550869-.064283v-1.107945z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <ellipse
          cx="296.62791"
          cy="156.148332"
          fill="#dce2ed"
          fillRule="nonzero"
          rx="1.497911"
          ry="1"
        />
        <path
          d="m162.842184 260.041764s-33.655837-1.418017-37.198756-67.45983c-3.542918-66.041813 31.531596-77.227137 31.531596-77.227137s11.111708-6.220371 16.039346-6.477505c4.927637-.257133 21.397113 1.297014 21.397113 1.297014l-18.156041-3.509121s25.547497-9.7446182 33.203068-10.5235826l-27.618916 5.8460146s-.377307-15.3334986 6.225576-20.4005486c0 0-5.659614-.4235146-8.644117 10.6218982-1.722744 6.4627086-6.401213 11.7238914-12.60962 14.1801774-10.243901 4.004482-24.408028 10.32695-27.634008 15.741887 0 0-5.965233 6.239279-5.055922-10.005533.909311-16.2448108 5.184206-30.1527288 6.742487-30.542211 0 0 12.187035-12.9928238 29.30548-13.7717882 0 0-9.983559-4.0309518-26.841662 8.5761712 0 0-1.426222-6.3678449 4.927637-13.9079179 6.35386-7.540073 16.224227-23.3916206 26.969947-25.0781163 0 0-15.039481-.9113128-26.969947 18.5817044 0 0-4.410725 2.8587237-4.799352-4.4166526s-2.98073-16.3771595-2.98073-16.3771595-3.633472 16.7666417 4.018326 24.3029333c0 0-14.654627 19.1035349-14.005658 40.5477446 0 0-4.527691 9.744618-6.221802-1.6902773 0 0-.977227-15.7494503-2.927907-29.1166308-1.594697-10.8841893 1.404723-21.9423476 8.278128-30.519523 3.241073-4.0422959 5.497372-7.967369 4.244711-10.0282215l-16.978842 20.2719816s-14.281092-33.1286757-24.653278-40.26035956c-10.3721857-7.13168386-11.6701239-8.69717544-11.6701239-8.69717544l16.7260456 19.6215841-21.0047137-7.4341943 21.0047137 9.7446178s9.7269893 7.9408994 15.3035963 29.6308986c5.576606 21.6899993 6.093517 35.2159978 6.093517 35.2159978s-29.9544495-23.7811028-35.6593403-23.0021383l19.3822913 14.6944451c10.668342 8.0835576 17.315037 20.4061116 18.220183 33.7790732s-37.4741897-9.616051-46.5522104-11.434895l-17.1146724-17.5456062 12.968062 16.6380747-26.7133776-.378138-15.2998229-10.9168459s12.073843 10.1378815 10.8890972 10.7882789c-1.1847459.6503975-18.8012374 1.4293615-18.8012374 1.4293615s44.8656459-.260915 49.8046022 2.987291c4.9389564 3.248206 15.948792 4.420434 15.948792 4.420434l-31.7692993 4.806135 37.86659-2.726376s28.6565116 5.195617 30.2110186 14.165052c0 0-5.836948 15.261652-9.723216 21.311861-3.229753 5.029237-9.72699 21.311862-11.021155 35.609262s-3.1127878 36.255877 1.814849 49.641965c4.927638 13.386087 6.742487 21.054727 4.278669 25.081897-2.463819 4.027171-4.799353 9.226569 3.241072 10.266449 8.040425 1.039879 43.311138-.518049 43.311138-.518049s10.75704 2.117573 8.678075-5.834671z"
          fillRule="nonzero"
          stroke="#eff1fb"
        />
        <path
          d="m143.991897 252.951676c-3.52779-1.802523-7.574157-2.3096-11.436194-1.433144-6.602882 1.433144-16.718499.673086-17.63913.514268"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m122.866444 175.130862s-1.60733 25.403315 1.248889 30.413645z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m116.935169 205.544507s2.0601 23.792447 3.486322 28.443545c1.426223 4.651098-3.486322-28.443545-3.486322-28.443545z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m114.927893 147.042767c-1.460181.536956-7.708394 13.234832-6.455733 16.997306s6.455733-16.997306 6.455733-16.997306z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m130.767265 133.860874c-.67538.306292-3.584422 7.623264-3.01846 9.786213.565961 2.16295 3.01846-9.786213 3.01846-9.786213z"
          fill="#eff1fb"
          fillRule="nonzero"
        />
        <path
          d="m103.714311 176.518629c.724431 7.377474 1.131923 12.206297.656515 18.112813-.387761 4.587115-.322042 9.201415.1962 13.77557"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m181.945267 90.6245681c-.879126 1.0058472-1.173426 2.4011767-1.21493 3.7397854-.041504 1.3386088.128284 2.6772175.041504 4.0120449-.094327 1.4028922-.754615 3.0515746-2.150654 3.2368616"
          fill="#eff1fb"
          fillRule="nonzero"
        />
        <path
          d="m158.001328 46.64333c-1.775855 1.7656034-3.350115 3.7238082-4.693707 5.8384517-.390825.6661926-.836329 1.2986082-1.331896 1.8906903-.754615.824341-1.712976 1.410455-2.573238 2.1137918-2.02104 1.645251-3.459232 3.8994453-4.101333 6.4283471"
          fill="#eff1fb"
          fillRule="nonzero"
        />
        <path
          d="m90.2142454 8.67070578c.4268686.83130686.9892433 1.58534632 1.6639265 2.23101452.5885998.5596444 1.2602073 1.0360983 1.7922111 1.648682.4207504.5342829.7992094 1.1006923 1.1319227 1.6940585 1.3658535 2.1894194 3.0826031 4.1368304 4.7955795 6.050209"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m121.613783 46.265192c-1.131923.6995554-1.407357 2.1969821-1.384719 3.516684.022639 1.3197018.249023 2.6961243-.237703 3.9212917-.222612.5596443-.584827 1.0512238-.818758 1.6033053-.399946.952908-.399946 2.0192573-.377307 3.0553556.018865 1.1949163.056596 2.3936139.109419 3.5885302.060369 1.4369246.1962 3.0024162 1.173426 4.0574214"
          fill="#eff1fb"
          fillRule="nonzero"
        />
        <path d="m112.215051 83.5685119c1.043098.555626 2.019158 1.2293338 2.909042 2.0079131.890048.7865909 1.486228 1.8535421 1.690338 3.0251045.064142.5029236.030184 1.0171914.143377 1.5125522.192779.6745095.531596 1.2981175.992319 1.8264069.75126.9676587 1.572212 1.8788869 2.456272 2.7263754" />
        <path
          d="m120.681834 117.479933c-.737108-.606977-1.521946-1.153273-2.346854-1.633556-.752009-.461852-1.563074-.819302-2.410995-1.062568-1.294165-.344106-2.641153-.291166-3.984368-.431077-1.343215-.139912-2.724161-.510487-3.629699-1.512553"
          fill="#eff1fb"
          fillRule="nonzero"
        />
        <path
          d="m67.9568705 101.061179c1.5771458.045376 3.2146607.102097 4.6182449.824341.7168845.378138 1.339442.899968 2.0412341 1.293232.9111579.505998 1.9352693.772671 2.9769569.775183"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m89.8331647 107.587842c-.3395768-.264697-.8527151-.060502-1.1319227.264696-.2792077.325199-.4339038.756276-.7244306 1.058787-.5772806.623928-1.5092304.695774-2.3657186.726025"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m98.8545893 73.9978375 1.5092307.7978713c1.577948.7588955 3.077981 1.6707752 4.478641 2.722594"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m116.180554 88.8624447c.996092-.238227 1.856353.8281224 2.033688 1.837751.177334 1.0096286-.030185 2.075978.252796 3.0629183.316751.8577385.834329 1.6267374 1.50923 2.2423587"
          fill="#eff1fb"
          fillRule="nonzero"
        />
        <path
          d="m133.046203 90.7115399c.909312 2.7150312-1.014957 5.6720709-.452769 8.4816367.169789.8545924.565962 1.6486824.754615 2.4994924.524458 2.231015-.377307 4.605722-1.833715 6.379189"
          fill="#eff1fb"
          fillRule="nonzero"
        />
        <path
          d="m76.212361 68.684998h2.622288v144.932757h-2.622288z"
          fill="#afb6d4"
          fillRule="nonzero"
        />
        <path
          d="m81.3248785 240.726472c-2.4689032 1.924595-5.9261907 1.924595-8.3950939 0-1.1696536-7.755612 1.8035303-22.998357 2.5053224-26.416725l.14715-.691993h3.3580375c.2233254.226211.4013519.493196.5244576.786528 2.3242148 4.961171 1.8601264 26.32219 1.8601264 26.32219z"
          fill="#535f89"
          fillRule="nonzero"
        />
        <path
          d="m78.2498216 210.486771v3.130983h-1.4149034v-3.134764c.2282548-.037141.459237-.054851.6904729-.05294.2426031-.000574.4848599.018394.7244305.056721z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m79.4647521 214.404282c-.5978209.313413-1.2648148.470775-1.939361.457547-.7349337.018624-1.459965-.17287-2.0902841-.552082l.14715-.691993h3.3580375c.2233254.226211.4013519.493196.5244576.786528z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <ellipse
          cx="77.525391"
          cy="212.64594"
          fill="#dce2ed"
          fillRule="nonzero"
          rx="2.829807"
          ry="1.682714"
        />
        <path
          d="m65.0817867 45.3387537 9.9684666-4.7834465 14.6961307 3.5204654-11.4060085-8.6366734z"
          fill={fillContrast}
          fillRule="nonzero"
        />
        <path
          d="m67.9983743 46.8664315-2.9165876-1.5276778 9.9684666-4.7834465 14.6961307 3.5204654-2.5883301 1.2629811-12.1078006-2.722594z"
          fill={fillContrast}
          fillRule="nonzero"
        />
        <path
          d="m67.9983743 46.8664315-2.9165876-1.5276778 9.9684666-4.7834465 14.6961307 3.5204654-2.5883301 1.2629811-12.1078006-2.722594z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m67.6022014 45.7395801 8.0215594 22.521903h3.976822l7.4254134-23.9172325-11.9757429-2.7906589z"
          fill="#dadff6"
          fillRule="nonzero"
          opacity=".2"
        />
        <path
          d="m81.5701285 61.9238891-1.588465 5.1086453-.3810807 1.2327301h-3.976822l-.298073-.8356852-1.8714457-5.2599004 3.0071416-1.8150627z"
          fill={fillContrast}
          fillRule="nonzero"
        />
        <path
          d="m75.0502533 42.6161597 1.8978571 25.6453234h-1.3243496l-7.6253865-21.3950516z"
          fill={fillColor}
          fillRule="nonzero"
          opacity=".2"
        />
        <path
          d="m78.3403755 35.4390992-3.2901222 5.116208-9.9684666 4.7834465z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m79.9854366 67.0325344-.3773076 1.2327301h-3.9843682l-.2942999-.8356852c.448996-.5672071 1.4186765-.9604706 2.5505993-.9604706.7413236-.0196121 1.4724882.1760569 2.1053764.5634257z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m78.2498216 68.6849977v2.1932008c-.1207384 0-.2452499.0189136-.3773076.0189136-.3521166.0006106-.7030253-.0412864-1.045142-.1247923v-2.0873221z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <ellipse
          cx="77.876287"
          cy="68.684998"
          fill="#dce2ed"
          fillRule="nonzero"
          rx="2.829807"
          ry="1.682714"
        />
        <ellipse
          cx="339.112745"
          cy="260.026639"
          fill={fillColor}
          fillRule="nonzero"
          opacity=".1"
          rx="6.346314"
          ry="1.073912"
        />
        <path
          d="m334.852942 255.031435s3.61838-.113441 4.708799-.892406c1.090419-.778964 5.56906-1.705402 5.836949-.457547.267888 1.247856 5.440775 6.209027 1.354534 6.24306-4.086241.034032-9.496832-.639054-10.583478-1.304577s-1.316804-3.58853-1.316804-3.58853z"
          fill="#eff1fb"
          fillRule="nonzero"
        />
        <path
          d="m346.824912 259.489683c-4.086241.034032-9.493059-.639054-10.564612-1.304577-.826304-.506705-1.158335-2.321767-1.267754-3.157452h-.120738s.226384 2.923007 1.316803 3.58853 6.497237 1.334827 10.583478 1.304576c1.180973 0 1.584692-.431077 1.565827-1.055005-.184881.381919-.633877.616365-1.513004.623928z"
          fill="#afb6d4"
          fillRule="nonzero"
          opacity=".2"
        />
        <ellipse
          cx="375.915328"
          cy="247.502706"
          fill={fillColor}
          fillRule="nonzero"
          opacity=".1"
          rx="4.88236"
          ry="1"
        />
        <path
          d="m372.636525 243.657042s2.78453-.086972 3.625926-.68443 4.282441-1.31592 4.48996-.35545c.207519.960471 4.188114 4.779666 1.041369 4.802354s-7.304675-.487798-8.142298-1.002066-1.014957-2.760408-1.014957-2.760408z"
          fill="#eff1fb"
          fillRule="nonzero"
        />
        <path
          d="m381.850376 247.086754c-3.142972.02647-7.304675-.491579-8.142298-1.002066-.63765-.378138-.894219-1.788593-.977226-2.431427h-.094327s.177334 2.249921 1.014957 2.760408c.837623.510486 4.999326 1.028535 8.142298 1.002065.909311 0 1.222477-.32898 1.203611-.809215-.124511.294948-.471634.476454-1.147015.480235z"
          fill="#afb6d4"
          fillRule="nonzero"
          opacity=".2"
        />
        <ellipse
          cx="353.759826"
          cy="299.7992"
          fill={fillColor}
          fillRule="nonzero"
          opacity=".1"
          rx="11.655032"
          ry="1.973881"
        />
        <path
          d="m345.934466 290.621789s6.64816-.207975 8.651663-1.637337c2.003504-1.429362 10.228809-3.138546 10.726855-.843248s9.991105 11.404644 2.482684 11.465146-17.439157-1.168447-19.420022-2.389833c-1.980864-1.221386-2.44118-6.594728-2.44118-6.594728z"
          fill="#eff1fb"
          fillRule="nonzero"
        />
        <path
          d="m367.931499 298.808479c-7.508421.060502-17.44293-1.172228-19.44266-2.389833-1.509231-.93022-2.128015-4.269179-2.331761-5.808201h-.222612s.422585 5.384686 2.44118 6.606072c2.018596 1.221386 11.93424 2.454116 19.438888 2.389833 2.169518 0 2.916587-.786527 2.875083-1.932286-.320711.676867-1.147015 1.12307-2.758118 1.134415z"
          fill="#afb6d4"
          fillRule="nonzero"
          opacity=".2"
        />
        <path
          d="m233.493031 206.928492s19.329468-.816778 21.363156-38.744026c2.033687-37.927248-18.110765-44.355595-18.110765-44.355595s-6.380271-3.573404-9.210078-3.720878-12.288909.756276-12.288909.756276l10.425009-2.015476s-14.669719-5.596443-19.065352-6.050209l15.846918 3.357866s.222612-8.806835-3.576876-11.72228c0 0 3.2373-.242008 4.965368 6.099367.986224 3.713173 3.673527 6.736202 7.240533 8.145094 5.885999 2.302861 14.02075 5.932986 15.873331 9.041281 0 0 3.425952 3.584749 2.901495-5.747699-.524458-9.332447-2.976957-17.318723-3.871176-17.541824 0 0-6.999056-7.4606642-16.831692-7.9106485 0 0 5.735076-2.3104236 15.416789 4.9157945 0 0 .818757-3.6565948-2.829807-7.9862756-3.648565-4.3296808-9.308179-13.4352453-15.49225-14.4032788 0 0 8.640344-.5256119 15.49225 10.6710562 0 0 2.531734 1.6411191 2.754345-2.5373064.222612-4.1784256 1.712977-9.4042937 1.712977-9.4042937s2.08651 9.6273951-2.309123 13.9570759c0 0 8.417732 10.9660034 8.044198 23.2895234 0 0 2.607195 5.596443 3.576876-.971815 0 0 .558415-9.045062 1.679019-16.7174837.914567-6.2516736-.807796-12.6028248-4.754076-17.5304806-1.860126-2.3179863-3.158065-4.5754705-2.437407-5.7590426l9.757174 11.6428709s8.191348-19.0316887 14.149035-23.1382681c5.957687-4.1065793 6.704756-4.9989851 6.704756-4.9989851l-9.591159 11.2722956 12.073843-4.2540532-12.073843 5.6002247s-5.584152 4.5376568-8.787494 17.0162128c-3.203341 12.4785561-3.501414 20.2266053-3.501414 20.2266053s17.193907-13.6318775 20.484029-13.2008001l-11.134347 8.4362601c-6.127302 4.643622-9.945258 11.721144-10.466513 19.402264s21.506533-5.524597 26.739789-6.568258l9.809998-10.077379-7.429187 9.551767 15.341327-.223101 8.791267-6.269529s-6.927368 5.823326-6.267079 6.197682c.660288.374357 10.802316.82056 10.802316.82056s-25.770108-.147474-28.599915 1.716747c-2.829807 1.86422-9.161029 2.537306-9.161029 2.537306l18.254142 2.783096-21.74801-1.569273s-16.458157 2.987291-17.356149 8.137531c0 0 3.354264 8.765241 5.587925 12.24033 1.85258 2.885193 5.584152 12.240329 6.327448 20.449706s1.788438 20.824063-1.041369 28.51161c-2.829806 7.687547-3.871175 12.100418-2.456272 14.40706 1.414904 2.306642 2.754345 5.293933-1.863899 5.895172-4.618245.60124-24.87589-.298729-24.87589-.298729s-6.180298 1.206261-4.984233-3.361647z"
          fillRule="nonzero"
          stroke="#eff1fb"
        />
        <path
          d="m244.317985 202.855945c2.024224-1.033631 4.345779-1.323962 6.56138-.820559 3.773075.820559 9.602478.378138 10.130708.294947"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m256.452198 158.160026s.92063 14.592348-.716885 17.466197z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m259.855512 175.626223s-1.180973 13.66591-1.99973 16.339346c-.818758 2.673436 1.99973-16.339346 1.99973-16.339346z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m261.010073 142.028656c.837623.310074 4.425818 7.604357 3.708934 9.759744s-3.708934-9.759744-3.708934-9.759744z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m251.913187 134.458332c.377308.173944 2.0601 4.378839 1.724296 5.619132s-1.724296-5.619132-1.724296-5.619132z"
          fill="#eff1fb"
          fillRule="nonzero"
        />
        <path
          d="m267.450714 158.957897c-.415038 4.238928-.641423 7.01068-.377308 10.402579.224123 2.634119.186206 5.284052-.113192 7.910648"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m222.517153 109.626006c.471228.614919.718818 1.372666.701792 2.147824.026411.756276-.075462 1.53524-.026412 2.302861.04905.76762.437677 1.750779 1.237569 1.860439"
          fill="#eff1fb"
          fillRule="nonzero"
        />
        <path
          d="m236.273788 84.3626018c1.016295 1.0183541 1.916077 2.1471428 2.682657 3.3654287.220386.3849181.472822.7504908.754615 1.092819.461249.4419964.955721.8477999 1.479046 1.2138232 1.16163.9481172 1.987276 2.2463327 2.354399 3.7019717"
          fill="#eff1fb"
          fillRule="nonzero"
        />
        <path
          d="m275.204385 62.5553797c-.245883.476879-.568387.9099601-.954588 1.281888-.339577.3214174-.724431.5936768-1.03005.9453452-.245287.3060075-.46607.6309566-.660288.9718148-.816982 1.2378989-1.737129 2.404213-2.750573 3.486433"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m257.172855 84.1470631c.645196.4008263.811211 1.2629811.796119 2.0192572-.015092.7562762-.143377 1.5503661.139604 2.2688284.128285.3214174.335804.6050209.467861.9226569.193467.56206.269248 1.1580555.222612 1.7507792 0 .6882113-.033958 1.3764226-.064142 2.0608525-.033958.8281223-.113193 1.7243095-.671608 2.3331118"
          fill="#eff1fb"
          fillRule="nonzero"
        />
        <path d="m262.568354 105.561022c-.598063.313752-1.158787.69431-1.671473 1.134414-.512859.454225-.855065 1.070751-.96968 1.746998-.037731.287385-.018866.582332-.083008.865936-.111462.386593-.305914.744087-.569735 1.047442-.431022.556151-.902699 1.079424-1.41113 1.565492" />
        <g fillRule="nonzero">
          <path
            d="m257.704859 125.050257c.424161-.346982.874504-.660514 1.346988-.937782.433513-.265314.900483-.471335 1.388492-.612584.75521-.134408 1.519637-.21026 2.286484-.226883.775615-.026541 1.51598-.331121 2.086511-.858373"
            fill="#eff1fb"
          />
          <path
            d="m288.006432 115.619494c-.905539.02647-1.845035.056721-2.641154.472673-.411265.211757-.754615.518049-1.173426.756276-.522642.291887-1.110891.445454-1.709204.446203"
            fill="#eff1fb"
          />
          <path
            d="m275.423223 119.366842c.224709-.120256.503512-.055651.652743.151255.162242.185288.249023.427296.418811.608803.328258.359231.867807.400826 1.354534.415952"
            fill="#eff1fb"
          />
          <path
            d="m270.24279 100.07802-.87158.453765c-.904111.438237-1.76341.963817-2.565692 1.569273"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m260.293189 108.608814c-.573508-.136129-1.067781.476454-1.169654 1.058787s0 1.191135-.14715 1.758342c-.179018.492012-.472653.934083-.856488 1.289451"
            fill="#eff1fb"
          />
          <path
            d="m250.60393 109.660038c-.520685 1.557929.584827 3.25955.260342 4.870418-.0981.49158-.324484.949127-.44145 1.436925-.301846 1.281888.218839 2.646967 1.052689 3.664158"
            fill="#eff1fb"
          />
          <path
            d="m138.03421 140.939619c-6.195391 8.371976-11.29659 33.000108-12.726585 40.422959l-10.790998-.427296c.679154-6.386752 13.726451-32.175768 17.35615-39.250731 1.943134-.260916 4.022099-.525612 6.161433-.744932z"
            fill="#dadff6"
          />
          <path
            d="m268.069498 137.967454h4.78426v6.753546h-4.78426z"
            fill="#dce0ed"
          />
          <path
            d="m272.853759 137.967454v2.196982c-.337452.095923-.686847.143036-1.037596.139911l-3.742891-.030251v-2.306642z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m266.050903 120.762172h4.527691c2.209532.002915 4.196274 1.349274 5.021964 3.403242 1.320577 3.263332 2.44118 8.451386-.501819 13.612971-.667682 1.178067-1.91943 1.901541-3.271257 1.89081l-5.76526-.049278z"
            fill="#dce0ed"
          />
          <ellipse
            cx="266.050903"
            cy="130.192935"
            fill="#f0f0f4"
            rx="4.837083"
            ry="9.426982"
          />
          <path
            d="m225.584663 138.046863h4.78426v5.910298h-4.78426z"
            fill="#dce0ed"
          />
          <path
            d="m230.368924 138.046863v1.89069c-.338687.096179-.689364.143294-1.041369.139911l-3.742892-.034032v-1.985225z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m223.566068 120.845362h4.527691c2.209113.001335 4.195551 1.3485 5.018191 3.403243 1.32435 3.263331 2.444953 8.451385-.498046 13.61297-.669522 1.17808-1.92228 1.901304-3.27503 1.890805l-5.761487-.053054z"
            fill="#dce0ed"
          />
          <ellipse
            cx="223.566068"
            cy="130.272344"
            fill="#f0f0f4"
            rx="4.837083"
            ry="9.426982"
          />
          <path
            d="m224.773452 124.2902s-1.784665.287385-.856488 2.646966c.492608 1.145746.850929 2.344896 1.06778 3.573405 0 0 1.784665.93022 1.712977-2.144043-.071689-3.074262-1.924269-4.076328-1.924269-4.076328z"
            fill="#dce0ed"
          />
          <ellipse
            cx="43.522431"
            cy="258.998103"
            fill="#000"
            rx="28.218835"
            ry="30.995977"
          />
          <path
            d="m54.0945896 229.934412c-14.7640461.994503-26.4605815 14.463781-26.4605815 30.935475 0 13.276427 7.5989749 24.601662 18.2805529 29.014533 14.7678191-.994503 26.4643545-14.463781 26.4643545-30.935475 0-13.276427-7.602748-24.601662-18.2843259-29.014533z"
            fill="#000"
            opacity=".1"
          />
          <ellipse
            cx="264.375657"
            cy="191.250888"
            fill={fillColor}
            rx="22.902571"
            ry="29.929628"
          />
          <path
            d="m257.97652 162.572897c-9.500605 3.649033-16.435518 15.125523-16.435518 28.719586 0 14.528065 7.923459 26.636045 18.427702 29.358639 9.496833-3.649032 16.435519-15.125522 16.435519-28.719586 0-14.528064-7.923459-26.636045-18.427703-29.358639z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m178.34198 184.860355.426357-10.863907s-2.128014-4.688912-4.252256-5.112426c-2.124242-.423515-7.014148-.691993-7.014148-.691993s-3.825899 15.601976-1.2753 20.290888 12.115347-3.622562 12.115347-3.622562z"
            fill="#dadff6"
          />
          <path
            d="m178.34198 184.860355.426357-10.863907s-2.128014-4.688912-4.252256-5.112426c-2.124242-.423515-7.014148-.691993-7.014148-.691993s-3.825899 15.601976-1.2753 20.290888 12.115347-3.622562 12.115347-3.622562z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m139.124629 183.688127s-1.316804-15.065021 6.942459-15.33728c1.064008-.034033 2.128015-.060502 3.18825-.162599 5.723756-.555863 21.340517-1.762124 19.469071 1.811281 0 0-3.720253 13.102484-1.169653 16.403629z"
            fill="#dadff6"
          />
          <path
            d="m256.195628 211.621185 11.077751.321418s1.91295-20.453488 2.5506-22.049231c.63765-1.595742.958361-9.268164-1.113058-10.383671-2.071418-1.115507-9.002559-2.476804-9.002559-2.476804l-5.108745 11.657996-.396173 10.546271z"
            fill="#dadff6"
          />
          <path
            d="m256.195628 211.621185 11.077751.321418s1.91295-20.453488 2.5506-22.049231c.63765-1.595742.958361-9.268164-1.113058-10.383671-2.071418-1.115507-9.002559-2.476804-9.002559-2.476804l-5.108745 11.657996-.396173 10.546271z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m229.410562 177.67195-.04905-2.268828c-.007642-.362627.134829-.712248.393582-.96584.258753-.253591.610703-.388529.972272-.372769 5.493599.230664 25.475809 1.191135 28.97345 2.979728 0 0-3.825899 28.519173.399946 35.310532l-1.433769 22.847102-48.944341-3.675502z"
            fill="#dadff6"
          />
          <path
            d="m225.584663 141.6543c1.358308-.13613 2.976957-.279823 4.784261-.423515v2.726375h-4.784261z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m272.853759 144.373112v.344106h-4.780487v-2.072197c1.659068.374321 3.264993.954844 4.780487 1.728091z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m138.011571 177.792954c.021097-.11461.086099-.2164.181108-.283603.104882-.038745.218084-.049177.328257-.030251v.19285c-.242803.217819-.470944.451516-.682926.699556.067915-.192851.116965-.385701.173561-.578552zm17.314646-5.089738c.001791-.026439.001791-.05297 0-.079409.240836-.605508.51674-1.196409.826303-1.769686-.301846.582332-.581053 1.198698-.826303 1.849095zm2.580784-4.893107c-.407493.608803-.901766 1.39533-1.388492 2.306643.364176-.824353.830692-1.599356 1.388492-2.306643zm-67.413548 52.916641c1.9204957.075628 3.5202799.041595 3.5202799.041595-.347123.158818-1.8903111.086972-3.5202799-.041595zm3.5240529.037814c.0716885-.045377.7810268-.461329 2.4374071-.294948 0-.015125-1.6299688-.071846-2.4374071.294948zm64.4479101-29.08638.701792-12.100418s-.260342 6.178776-.173562 8.852212c.03228 1.107825-.147013 2.211624-.52823 3.251987z"
            fill="url(#a)"
          />
          <path
            d="m118.312342 214.850484s-.199973.620147-.464089 1.406674c-.43013 1.281888-1.037595 3.025105-1.245115 3.187704-.207519.162599-1.814849.268478-3.565556.378138-2.714106.158159-5.390818-.694295-7.515968-2.393614 0 0 .916858-.661742 1.886538-1.429362.969681-.76762 1.988411-1.637338 2.195931-2.064634.290526-.586114 1.95068-1.595742 2.950545-2.162949.448996-.257134.754615-.423515.754615-.423515z"
            fill="#f899a5"
          />
          <path
            d="m116.191873 220.193575s-17.6429029-.812997-18.6955911-1.047442c-1.0526881-.234446-1.2677535-1.474739-1.2677535-1.474739-.350896-.824341 1.5092304-.646616 1.5092304-.646616.1886538.030251 2.2638452.378138 4.2182992.627709 1.565826.200414 3.048645.336543 3.395768.18907.788573-.328981 2.361946-.18907 2.361946-.18907-.894219-2.964602-3.603288-3.67172-4.761622-3.838101l.071688-.071846c.308051-.287233.645761-.540756 1.007411-.756276 3.595742.147474 5.497372 5.116208 5.497372 5.116208h.030185c.407492.128567 4.742756 1.474738 5.603017 1.599524.897993.139911 1.03005.491579 1.03005.491579z"
            fill="#f3b4b4"
          />
          <path
            d="m106.966703 221.770411c-.067916.223101-.377308.378138-.8829.419733-.273824.01973-.548707.01973-.822531 0-1.677165-.144926-3.327096-.516341-4.904999-1.104163-.271661-.094534-.5282301-.177725-.7772531-.249571h-.0301847c-.5990268-.179552-1.2126179-.306083-1.8337149-.378138-1.5997841-.166381-2.2827109.249571-2.3506263.294948s-1.5469611.034032-3.3957683-.041596c-1.4217509-.039082-2.8383597-.18826-4.2371643-.446202-.199973-.041596-.3773075-.090754-.5621883-.139912-.3307443-.084238-.649111-.211357-.947042-.378138-1.9469072-1.172228 4.6106988-1.962536 4.6106988-1.962536.7492073-.091791 1.4470369-.429507 1.9846379-.960471l.0679154-.075627.1660153-.166381c.2536247-.221435.519413-.428474.796119-.620147l.2414769-.162599c1.3054843-.884843 3.0637376-1.830188 3.0637376-1.830188 1.22319-.333009 2.3413448-.973361 3.248618-1.86044.166903-.164813.318454-.344543.45277-.536956l3.625925-.937782 2.497777 6.012395s.018865.325199.037731.812997c.041503 1.308358.113192 3.781381-.04905 4.310774z"
            fill="#f899a5"
          />
          <path
            d="m106.083803 222.190144c-.273824.01973-.548707.01973-.822531 0-1.677165-.144926-3.327096-.516341-4.904999-1.104163-.271661-.094534-.5282301-.177725-.7772531-.249571h-.0301847c-.5990268-.179552-1.2126179-.306083-1.8337149-.378138-1.5997841-.166381-2.2827109.249571-2.3506263.294948s-1.5469611.034032-3.3957683-.041596c-1.4217509-.039082-2.8383597-.18826-4.2371643-.446202-.199973-.041596-.3773075-.090754-.5621883-.139912.2415169-.029827.4850522-.039944.7282037-.030251.1848807.022689 2.2827109.279823 4.2371643.442422 1.5771457.132348 3.0637376.204194 3.3957683.041595.7734805-.378138 2.3506263-.294948 2.3506263-.294948-1.0187305-2.923007-3.7730759-3.509121-4.9238641-3.626344.0226385-.026469.04905-.049158.0679154-.075627.2937754-.293634.6160874-.557118.9621343-.786527h.0754615c3.5504645.05672 5.6407486 4.866636 5.6407486 4.866636h.0301846c.411265.109661 4.803126 1.270544 5.659614 1.357516.237951.018141.471263.075639.690473.170162z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m106.291322 222.640129s-17.6617685-.045377-18.7220028-.230665c-1.0602344-.185287-1.3318958-1.421799-1.3318958-1.421799-.3773076-.805434 1.4677265-.707118 1.4677265-.707118.1848807.022688 2.2638456.279822 4.2371643.446203 1.5733726.128567 3.0637376.200413 3.3957683.041595.7546152-.378138 2.3506263-.294948 2.3506263-.294948-1.0225036-2.923007-3.7730759-3.509121-4.9238641-3.626344l.0679154-.075627c.2977708-.297108.6238054-.564336.9734536-.797872 3.5995144 0 5.71621 4.870419 5.71621 4.870419h.0301846c.4112653.105878 4.8031257 1.266762 5.6596137 1.353734.93195.094535 1.0791.442422 1.0791.442422z"
            fill="#f3b4b4"
          />
          <path
            d="m118.312342 214.850484s-.199973.620147-.464089 1.406674c-.105646-.071846-3.580649-2.389833-4.904998-3.909948-.155427-.171015-.289712-.360189-.399946-.563425.448996-.257134.754615-.423515.754615-.423515z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m128.477008 207.181845-.62633 2.030601-5.999191 3.274676s-1.622423 1.153321-1.886538 1.697839c-.214397.362849-.55612.632515-.958361.756277-.297088.370586-.574177.756839-.830077 1.157102 0 0-3.561784-2.367144-4.904999-3.909948-.415038-.476453-.615011-.87728-.426357-1.100381.7848-.945345 5.493598-4.341025 5.493598-4.341025s2.875084-3.781381 2.999596-3.713316c.124511.068065 1.569599-1.327265 2.418541-2.117573l.581054-.544519z"
            fill="#bdd3e8"
          />
          <path
            d="m157.080697 166.301339-5.840722 10.35342-2.143107 4.095235-11.413554-1.667589.256569-.5483.965907-2.030601.44145-.93022.067915-.124786 1.263981-2.295298.071688-.094534.916858-1.300795 1.845034-2.612934c.20941-.014393.414227-.068276.603692-.158818.321184-.165153.56793-.446224.690473-.786527.652742-1.618431-.543323-4.730508-.543323-4.730508s4.331491-10.587865 5.833175-4.760758c1.109285 4.322118 4.40318 6.40944 6.036922 7.184623.306932.155665.623223.292058.947042.40839z"
            fill="#f899a5"
          />
          <path
            d="m137.460702 201.895474v1.002066s3.773076 3.618782 3.27503 6.568258c-.498046 2.949477.554642 6.624979.554642 6.624979l3.795715-.272259-.573508-13.476841z"
            fill="#bdd3e8"
          />
          <path
            d="m145.086089 215.818518-3.795715.272259s-1.052688-3.67172-.554642-6.624979c.498046-2.953258-3.27503-6.568258-3.27503-6.568258v-1.002066l7.051879.446203.037731.877281z"
            fill="#000"
            opacity=".05"
          />
          <path
            d="m124.070056 201.505992c-1.200996 1.118193-2.313619 2.328084-3.327853 3.618781-1.335669 1.781031-3.610834 4.341025-3.610834 4.341025l-2.720388 1.61465-1.131922 1.100382c-.415039-.476454-.615012-.877281-.426358-1.100382.7848-.945345 5.493599-4.341025 5.493599-4.341025s2.875083-3.781381 2.999595-3.713316c.124511.068065 1.569599-1.327264 2.418542-2.117573z"
            fill="#000"
            opacity=".05"
          />
          <path
            d="m107.004433 217.459637c-.110262.094545-.214834.195559-.313165.302511 0 0-.056596 1.777248-1.445088-2.397396s-4.83331-3.172578-4.83331-3.172578c-.025321-.015955-.036279-.04733-.026412-.075628 0-.113441.199973-.310073.452769-.536956l3.625926-.937782 2.497776 6.012395s.022639.317636.041504.805434z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m119.798934 193.712567-2.112923.05672-1.445088 2.060853s-2.388357 2.559995-3.109014 3.199048c-.720658.639053-5.387953 5.036799-6.719849 7.320753 0 0-1.222476.612583-1.222476 1.225167s-2.331761 2.393614-2.331761 2.393614-2.444953 1.667589-2.112923 1.89069c0 0 3.444819-1.002065 4.833311 3.172579s1.445088 2.393614 1.445088 2.393614c.239989-.263748.521715-.486047.833849-.657961.332031-.121004 1.91295-2.401176 2.399677-2.457897.359165-.071208.69731-.223838.988546-.446203l2.829807-2.783096 2.72416-1.61465s2.263846-2.559994 3.607061-4.341025c1.01623-1.290161 2.130064-2.499997 3.331626-3.618781z"
            fill="#bdd3e8"
          />
          <path
            d="m109.24564 207.185626s3.773076 1.83397 3.610834 2.223452-3.610834-2.223452-3.610834-2.223452z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m112.22637 206.739423s.2943 1.652463 1.795985 1.576836c1.501684-.075628-1.795985-1.576836-1.795985-1.576836z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m106.966703 211.379177s.222611.945345 1.611103 1.111726-1.611103-1.111726-1.611103-1.111726z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m121.104418 207.185626s1.829942.756276 1.995957 1.8075c.166016 1.051224-1.995957-1.8075-1.995957-1.8075z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m116.603138 211.080448c.709339.306292 2.750573 2.60159 2.709069 2.851161s-2.709069-2.851161-2.709069-2.851161z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m119.851757 209.450673c.434019-.154549.917848-.052312 1.252661.264697.509365.529393-1.252661-.264697-1.252661-.264697z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m133.310319 191.266013s-7.082064-2.299079-6.538741 0c.543323 2.29908 6.538741 3.588531 6.538741 3.588531z"
            fill="#f899a5"
          />
          <path
            d="m157.080697 166.301339-5.840722 10.35342-2.143107 4.095235-11.413554-1.667589.256569-.5483c.266996-.370974.571737-.713135.909311-1.020973-.026323-.337564-.007287-.677143.056596-1.009628.058602-.395456.236318-.763542.509365-1.055006l.045277-.041595c.535777-.472672 1.045142-1.694058 1.290392-2.348237.0981-.260915.150923-.434859.150923-.434859l.754616-.865936 2.448726-2.771752.690473-.786527.648969-.733588-2.324215 3.312489s-1.109284 2.004132-1.16588 2.268829c-.056597.264696-1.886538 2.726375-1.886538 2.726375s-3.109015 2.730157 2.444953 2.783096c5.553968.05294 8.94219-5.36956 8.94219-5.36956l4.68616-7.275377c.30493.148945.618684.279016.939496.389483z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m144.550312 203.218958-2.177065-.151256-4.916318-.41217v-.756276l7.055652.442421z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m156.122336 165.325742s.999865 1.111726 1.99973 1.168447c0 0-1.833715 1.947411-2.501549 3.841883 0 0-3.116561 5.256119-.886673 7.0674s3.524053 2.170513 3.524053 2.170513l-.675381 12.100418s1.648834 8.319037 2.263846 8.939183c.615011.620147.445223 2.004132.445223 2.004132s-.40372 1.391548.018865 1.89069c.422584.499143.535777 3.062919.535777 3.062919s-2.497777-1.281888-3.018461-1.281888-1.886538-2.616716-1.886538-2.616716l-13.583073-.945345-5.972779-.499142.943268-16.638075s-2.720387-4.473373.999866-7.914429c0 0-.143377-1.440707.611238-2.106229.754615-.665523 1.445088-2.783097 1.445088-2.783097l4.554103-5.157803-2.331761 3.323834s-1.113058 2.004131-1.165881 2.268828-1.886538 2.730157-1.886538 2.730157-3.109014 2.726375 2.444953 2.783096c5.553968.056721 8.94219-5.399811 8.94219-5.399811z"
            fill={fillColor}
          />
          <path
            d="m151.677652 187.25775s1.931815 1.418018 3.999461 1.474738c2.067645.056721-3.999461-1.474738-3.999461-1.474738z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m154.175429 182.761688s1.528095-.756276 2.388357-.124785c.860261.63149-2.388357.124785-2.388357.124785z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m153.454771 185.287651s.0981.892406 2.361946 1.002066c2.263845.10966-2.361946-1.002066-2.361946-1.002066z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m157.952278 166.494189.475407.253352c.96248.35722 1.971615.572483 2.995822.639054 1.916723.166381 3.584422 2.004132 3.916453 3.754911.083008.43864.150923 1.024754.207519 1.652463.192516 2.266642.157122 4.546941-.105646 6.806485-.181107 1.599524-.377307 3.403243-.267888 3.667939.166015.499143-.916858 8.266099-.916858 8.266099s-.249023 6.345156-1.833715 6.93127c-1.584691.586114-10.413689.582333-10.413689.582333l-3.746664-6.511538 8.74599.415952c.767016-1.37434 1.141665-2.933796 1.082872-4.507405-.083007-2.673437.166016-8.852213.166016-8.852213s-5.282307-1.134414-4.210753-5.267463c1.071553-4.133049 3.905134-7.831239 3.905134-7.831239z"
            fill="#f899a5"
          />
          <path
            d="m141.290374 216.090777s-3.527826 1.168447-4.904998.555863c-1.377173-.612583-4.372995-2.949477-4.372995-2.949477s-1.924269-1.89069-3.754211-4.004482l-.233931-.272259c-1.584692-1.849095-3.01846-3.781381-3.01846-4.73807.009091-.397131-.040496-.793425-.14715-1.176009-.159626-.553354-.415049-1.074286-.754616-1.539022-.189596-.267027-.407158-.512956-.648969-.733588l-5.776579-7.460664s1.6677-1.78103 1.6677-2.268829c0-.487798 1.99973-3.225517 4.554102-1.777248 1.075327.60502 3.644792 2.862505 6.263306 5.271244 3.603288 3.31249 7.289583 6.916145 7.289583 6.916145s.260342.279822.641423.714681c.977227 1.134414 2.743026 3.270895 2.88263 4.352369.203746 1.482302.313165 9.109346.313165 9.109346z"
            fill="#bdd3e8"
          />
          <path
            d="m138.102125 202.610155c-2.73548 2.730157-6.851906 6.390534-9.840182 7.082526l-.079235.018907-.154696-.291166-3.154291-5.914079-.799892-1.512553.041504-.041595 6.05956-6.98421c3.603287 3.31249 7.289582 6.916145 7.289582 6.916145s.256569.291167.63765.726025z"
            fill="#000"
            opacity=".05"
          />
          <path
            d="m160.216123 207.726363v1.266763s1.750707 6.193901-1.414903 7.940899c-1.599785.888625-5.006872 1.100382-7.987602 1.093012-4.103253.011597-7.623251-2.92952-8.349817-6.97684-.117976-.591913-.129476-1.200189-.033958-1.796156 0 0-1.414903-10.145444-1.750707-10.209728 0 0-7.957417 9.132035-12.828458 10.183258l-4.112653-7.706453 6.568925-7.562762s4.874814-7.763174 6.289718-8.474073c1.414903-.7109 2.83358-2.699906 2.83358-2.699906s5.708664-4.772103 9.496832 3.28602c3.788168 8.058122 6.248214 14.565878 7.168844 16.98218 0 0 1.335669 2.737719 2.165746 2.730157h.026411c1.064939.010334 1.923964.876305 1.928042 1.943629z"
            fill="#00c"
          />
          <path
            d="m140.513121 198.613236c.763994-.845698 1.344697-1.840989 1.70543-2.923007.630104-1.837751-.188654 1.86422-1.539415 3.338959z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m133.099026 152.66568c.056597.529393.452769 1.002066.860262 1.444487.866289.939629 1.796709 1.817766 2.78453 2.62806.422584.351668.879126.718462 1.01873 1.176009.073639.339952.050099.693827-.067915 1.020973-.352047 1.279931-.848254 2.515565-1.479046 3.683065-.258335.368311-.401496.80532-.411265 1.255418.101873.990722 1.50923 1.546585 2.535507 2.200764 1.346988.873499 2.124242 2.193201 2.075192 3.509121-.083008 2.05329-2.026142 3.826757-2.482684 5.853577 1.260859-.013291 2.507338-.270068 3.671203-.756276 1.079099-.510486 1.886537-1.399111 1.841261-2.344456-.031002-.147186-.01104-.300566.056596-.434859.141733-.146065.327236-.241677.52823-.272259 1.007412-.24579 2.237434-.166381 2.976957-.729807.739523-.563425.569735-1.554147.252796-2.344456-.860261-2.162949-2.105376-4.242709-2.856218-6.428347-.301979-.726099-.413679-1.517527-.324485-2.299079.135831-.756276.599919-1.47852.996092-2.196982.867074-1.560331 1.428042-3.272609 1.652608-5.044362.120738-.998284.116965-2.038164-.407493-2.960821-.584826-1.03988-1.826168-1.864221-3.293895-2.185638-2.83358-.623928-4.34281.756276-6.557606 1.675152-1.648834.703336-3.535372 1.962536-3.369357 3.550716z"
            fill="#4b3648"
          />
          <path
            d="m137.932337 175.266992c.230157 0 .460315-.02647.690473-.045377.471634-2.007913 2.384584-3.78138 2.467591-5.804419.04905-1.31592-.731977-2.646966-2.075192-3.512902-1.011184-.654179-2.433634-1.210042-2.535507-2.196983.010156-.4512.153246-.88931.411266-1.259199.630792-1.1675 1.126998-2.403134 1.479045-3.683065.118015-.327146.141555-.681021.067916-1.020973-.139604-.457547-.596146-.824341-1.018731-1.172228-.987444-.817511-1.917802-1.701906-2.78453-2.646966-.407492-.43864-.803665-.911313-.860261-1.440706-.173562-1.58818 1.701657-2.851161 3.369357-3.550717 1.731842-.733587 3.018461-1.724309 4.88236-1.822625-2.218569-.143693-3.61838 1.005847-5.557741 1.822625-1.667699.699556-3.542918 1.962537-3.369357 3.550717.056597.529393.452769 1.002066.860262 1.440706.866728.94506 1.797086 1.829455 2.78453 2.646966.422584.347887.879126.714681 1.01873 1.172228.073639.339952.050099.693827-.067915 1.020973-.352047 1.279931-.848254 2.515565-1.479046 3.683065-.258019.369889-.40111.807999-.411265 1.259199.101873.986941 1.50923 1.542804 2.535507 2.196983 1.346988.873499 2.124242 2.196982 2.075192 3.512902-.083008 2.049509-2.026142 3.826757-2.482684 5.849796z"
            fill="#000"
            opacity=".1"
          />
          <ellipse
            cx="144.28997"
            cy="157.059644"
            fill="#000"
            opacity=".1"
            rx="8.874275"
            ry="8.893807"
          />
          <ellipse
            cx="144.455985"
            cy="156.726883"
            fill="#f899a5"
            rx="8.874275"
            ry="8.893807"
          />
          <path
            d="m138.992571 152.55602c-.694246-.21932-1.42245-.461328-1.886538-1.077693-.464088-.616366-.547096-1.728091.045277-2.234796.330711-.20769.690644-.364472 1.06778-.46511 1.490365-.661742 1.743161-2.979728 2.754346-4.427997.671308-1.016635 1.844562-1.582779 3.056191-1.474738.626202.140987 1.24253.322881 1.845034.544518 1.475273.400827 3.052419.083191 4.55033.35545 2.942999.540738 5.195526 3.316271 6.414229 6.428347.562188 1.433144.954588 2.949477 1.399811 4.443122.673753 2.239342 1.480106 4.43644 2.414769 6.579603.191232.510278.470971.982657.826304 1.395329.943268.964252 2.610968.892406 3.192022 2.18942.320711.718462.169788 1.599524.064142 2.41252-.359801 2.74465-.122971 5.534823.694246 8.179127.63765 2.02682 1.856353 4.076328 3.71648 4.367494-.713112.998285-2.10915.90375-2.992049.189069-.8829-.714681-1.411131-1.86422-2.003504-2.911663-.499985-.883749-1.071646-1.72479-1.709203-2.514618-.33377-.472402-.778167-.85545-1.294165-1.115507-1.267754-.514268-2.614742.536956-3.746665 1.45205-.931949.756276-1.939361 1.463394-3.052418 1.607087-1.182903.180265-2.322944-.521245-2.697749-1.660026-.426358-1.448269.433903-3.403243-.505592-4.454467-.339577-.378138-.837623-.518049-1.245116-.809215-1.199838-.854592-1.346988-2.809566-1.184745-4.465811.162242-1.656244.501819-3.433493-.139604-4.889325-.366942-.728215-.880885-1.372058-1.509231-1.89069-2.688035-2.488904-5.768147-4.515316-9.115751-5.99727"
            fill="#4b3648"
          />
          <g
            fill="#000"
            opacity=".1"
            transform="translate(136.67537 142.921062)"
          >
            <path d="m18.6282087 33.291275c-1.184209.182264-2.3264866-.5196404-2.7015224-1.6600261-.4263576-1.4444874.4376768-3.4032425-.5055922-4.4544663-.3395768-.3781381-.8376228-.5180492-1.2413419-.8054341-1.2036113-.854592-1.3507612-2.8095658-1.1847459-4.4658105.1660154-1.6562447.5018191-3.437275-.1433769-4.8931066-.3679558-.7275617-.8817437-1.3712102-1.5092303-1.8906903-2.68551644-2.5009971-5.76577296-4.5390033-9.11575148-6.03130207l1.0489151.24957112c-.69424597-.21932008-1.4262227-.46510982-1.88653796-1.07769348s-.54709601-1.72809095.04904999-2.23857733c.32955298-.20642985.68824334-.3619495 1.06400741-.46132844 1.50923037-.66174161 1.74316108-2.97972793 2.75434542-4.42799671.32855101-.4734266.76427725-.86216722 1.27152659-1.13441419-.92746399.15729726-1.75136417.68548101-2.28271093 1.4633943-1.01118435 1.44826878-1.26020736 3.78138063-2.75434543 4.42799672-.37713603.10063819-.73706991.25742021-1.06778049.46510981-.59237292.50670501-.52068448 1.62221229-.04527691 2.23479595.47540757.61258367 1.2073843.85837341 1.88653796 1.07769348l-1.04514203-.24578974c3.34785206 1.48921508 6.42676112 3.52334008 9.11197836 6.01995798.6283458.5186318 1.1422889 1.1624747 1.5092304 1.8906903.645196 1.4558315.3056191 3.2330804.1396038 4.8893251-.1660154 1.6562448 0 3.6112185 1.1847458 4.4658106.4074922.2911663.9055382.4235146 1.2451151.8092154.9394959 1.0550052.0792346 3.0061976.5055922 4.4544664.3748052 1.1387817 1.5148462 1.8402915 2.6977492 1.6600261.4228335-.0588446.8332233-.1865754 1.2149305-.3781381-.0655532.0226195-.1323147.0415558-.199973.0567207z" />
            <path d="m30.4303902 36.7550197c-.8828998-.7146809-1.4111304-1.8642207-1.9997303-2.9078817-.4989778-.8852658-1.0720266-1.7264909-1.7129764-2.5146181-.331779-.474214-.7766772-.8576946-1.2941651-1.1155073-.6610173-.2277201-1.3890091-.1472706-1.9846379.2193201.3291391-.0459926.6645541-.0056021.9734536.1172228.5166927.2590121.9613217.6422607 1.294165 1.1155072.6375572.7898281 1.2092186 1.630869 1.7092034 2.5146182.5923729 1.0474424 1.1319228 2.1969821 2.0035033 2.911663.7546152.5974582 1.8412611.7562762 2.5996493.207976-.5774375.0106852-1.1400608-.1835189-1.5884649-.5483002z" />
          </g>
          <path
            d="m296.846749 212.343429-7.229214.105879-14.933834-27.199471-2.494004-4.541438 1.91295-11.50296 1.471499 2.783096z"
            fill="#dce0ed"
          />
          <path
            d="m231.481981 178.897117-2.973184 4.473374-8.896913-12.055042-4.071149-5.520815 2.444954-3.301146 1.871445 2.276391z"
            fill="#dce0ed"
          />
          <path
            d="m219.857134 164.766098c0 .230664.026412.468891.041504.707118l-.286754 5.842233-4.071149-5.520815 2.444954-3.301146z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m275.574146 171.988535-.890445 13.261302-2.494004-4.541438 1.91295-11.50296z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m211.41299 173.251516s-3.56933-26.715454 9.43269-30.712373c.166742-.048681.33706-.084084.509365-.105879 2.99205-.359231 30.863761-3.580967 45.333508.24579 0 0 9.885459 1.493645 9.779812 6.806485l-4.384314 65.092686h-7.119794l2.335534-43.032111s3.395768-18.748086-2.229888-20.041318-31.248615-3.403242-40.281359-.85081c0 0-6.591563-1.493646-5.527556 14.804105l-.426357 8.734989z"
            fill="#dce0ed"
          />
          <path
            d="m233.077992 181.184853c.121748-1.434539-.513599-2.828496-1.675245-3.675502-1.992185-1.512552-8.130979-4.791009-8.130979-4.791009l-1.992184.158817-5.976552 14.860826.396173 31.555622 10.760812 13.340711z"
            fill="#dadff6"
          />
          <path
            d="m233.077992 181.184853c.121748-1.434539-.513599-2.828496-1.675245-3.675502-1.992185-1.512552-8.130979-4.791009-8.130979-4.791009l-1.992184.158817-5.976552 14.860826.396173 31.555622 10.760812 13.340711z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m190.140388 214.260589.211292-32.383744s-.954588-12.569309 6.538741-12.781066c0 0 17.669315.128567 25.347524 2.628059.490526.158111.883976.529118 1.071299 1.01019s.148616 1.021096-.105391 1.470396c-1.509231 2.665873-4.105107 9.725711-5.350222 27.830962v19.413608z"
            fill="#dadff6"
          />
          <path
            d="m227.418378 234.952304-32.154153-.752495h-.030184l-15.801642-.366794 1.829942-21.17195 8.768628.321417 27.901897 6.231716 8.527151 13.42012z"
            fill="#dadff6"
          />
          <path
            d="m227.418378 234.952304-32.154153-.752495h-.030184l-15.801642-.366794 1.829942-21.17195 8.768628.321417 27.901897 6.231716 8.527151 13.42012z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m227.418378 234.952304-32.154153-.752495-.52823-14.18774 23.196871-.797871 8.527151 13.42012z"
            fill="#dadff6"
          />
          <path
            d="m195.234041 234.199809-15.801642-.378138 1.833715-21.175731s4.942729 7.910648 13.469881 7.351003z"
            fill="#fff"
            opacity=".1"
          />
          <path
            d="m308.645157 251.325682c-.63765 6.072897-4.94273 5.112427-4.94273 5.112427l-.803665-.071847-7.964963-.726025.320711-9.426982s4.335265-.294947 8.078156.487798c2.988276.620147 5.595472 1.928505 5.312491 4.624629z"
            fill="#dce0ed"
          />
          <path
            d="m198.003478 159.298222s-14.665946 6.704388-15.729953 8.625329-8.300767 10.209728-8.300767 10.209728l3.135426 5.293932 14.507477-11.55968z"
            fill={fillColor}
          />
          <path
            d="m186.827628 193.576437-6.791537-1.017191-4.995553 5.906516s-6.961325 3.459963-7.772536 4.972516c-.811211 1.512552-3.342945 5.94433-4.459776 5.978362-1.11683.034033-2.161972 1.667589-2.169518 2.314205-.007547.646617-4.252257 8.073248-5.304945 8.500544s-2.878857 2.839817-2.83358 3.316271-3.96173 5.225868-3.96173 5.225868-6.791537 10.652149-7.802721 10.992473c-1.011184.340325-4.923864 7.218656-5.916183 8.035434s-3.773076 1.550366-3.433499 2.212108 7.168844 10.016877 6.753806 12.667625c0 0 5.082333-4.030952 5.282306-5.271245.199973-1.240292 6.489691-7.782081 6.489691-7.782081l32.942726-34.289559 6.350086-21.610591z"
            fill="#ceddf9"
          />
          <path
            d="m205.066677 204.591599s1.354534 15.586851-3.135426 17.946432c-4.489961 2.359582-7.546152 2.087322-8.410187 3.127202-.864034 1.03988-6.127475 1.958755-6.68589 2.9041-.558416.945346-15.307369 9.207662-15.307369 9.207662s-10.089205 5.959456-11.670124 7.25647c-1.580919 1.297013-10.187305 5.089738-11.655032 6.87455-1.467726 1.784811-10.681578 7.634607-10.681578 7.634607s-2.697749-8.319037-5.799217-9.048844c0 0 7.455598-1.470957 7.897048-2.646966.441449-1.17601 2.667564-2.438991 2.667564-2.438991s10.613663-6.171213 10.94192-7.562761c.328258-1.391548 2.943-3.372991 2.943-3.372991s4.214525-5.774169 5.76526-6.330032c1.550734-.555863 10.74572-10.016877 10.74572-10.016877s6.251987-3.312489 6.946233-4.401527 12.541704-7.260251 12.541704-7.260251l-13.503839-16.815799 4.271122-1.315921 12.651124 3.403243 2.263845 4.11036z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m205.828838 204.818482s1.358307 15.586851-3.131653 17.946432c-4.48996 2.359582-7.546152 2.091104-8.413959 3.127202-.867808 1.036098-6.127476 1.962536-6.685891 2.9041s-15.303596 9.211443-15.303596 9.211443-10.089205 5.955675-11.673897 7.241344c-1.584692 1.28567-10.187305 5.09352-11.655031 6.878332-1.467727 1.784811-10.681578 7.630826-10.681578 7.630826s-2.709069-8.296349-5.799218-9.052625c0 0 7.459371-1.467176 7.897048-2.646967s2.667565-2.442772 2.667565-2.442772 10.613662-6.171213 10.94192-7.562761c.328257-1.391548 2.946772-3.376773 2.946772-3.376773s4.214526-5.774168 5.76526-6.32625c1.550734-.552081 10.741947-10.020658 10.741947-10.020658s6.251987-3.31249 6.946233-4.401527c.694246-1.089038-5.357768-15.503661-5.357768-15.503661l4.406953-8.583734 4.271122-1.312139 12.651123 3.403242 2.263846 4.110361z"
            fill="#000"
          />
          <path
            d="m220.84568 164.024947-10.319363 7.184624s-12.470015-4.635973-7.546151-6.496412c3.229753-1.221386 4.39186-7.524948 4.806898-11.72228.218839-2.185638.230158-3.781383.230158-3.781383s14.0698-.022686 11.48147 4.477157c-.686592 1.239409-.986269 2.656791-.860261 4.068765.1962 3.331397 2.207249 6.269529 2.207249 6.269529z"
            fill="#fec2be"
          />
          <path
            d="m218.615792 157.7592c-4.268397.999906-8.684417-.934432-10.851366-4.753196.218838-2.185638.230158-3.781383.230158-3.781383s14.0698-.022686 11.48147 4.477157c-.684365 1.236124-.98397 2.649214-.860262 4.057422z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m225.912921 150.688018c-1.526006 5.175672-6.894875 8.184622-12.093769 6.77788s-8.327157-6.714888-7.04664-11.956986c1.280516-5.242097 6.50167-8.501696 11.761029-7.342483 5.25936 1.159212 8.634164 6.313441 7.601992 11.610276-.06037.302511-.132058.608803-.222612.911313z"
            fill="#fec2be"
          />
          <path
            d="m206.096726 159.993996s-1.731842 0-1.841261 2.469241c-.109419 2.469242-1.860126 2.287736-1.860126 2.287736l-8.134752 8.466511s-3.652337 8.76524-3.622153 9.12069c.030185.35545-.82253 1.837751-.630103 2.586464.192426.748714-.075462 3.025105-.754616 2.824691-.679153-.200413-1.811076.499143-1.795984 1.61465.015093 1.115507-5.71621 4.537657-5.482279 5.369561.233931.831903 16.318553 9.39673 16.318553 9.39673l6.693437 5.199399 6.248214-11.665559 5.206845-16.07465 2.893949-9.332447 2.395903-2.68478-1.101738-6.29978s-.988546-2.726376-1.795984-2.344456c-.807439.381919-3.773076 3.592311-6.557606 3.872133-2.78453.279823-4.410726.620147-5.059695 0-.648969-.620146-4.591834-1.066349-1.120604-4.806134z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m206.655142 159.173436s-2.0601.060502-2.173292 2.525962c-.113192 2.465461-1.860127 2.287736-1.860127 2.287736l-8.134751 8.466511s-3.652338 8.761459-3.61838 9.12069-.826304 1.83397-.633877 2.586464c.192427.752495-.071688 3.025105-.754615 2.824692-.682927-.200414-1.81485.499142-1.799757 1.614649.015092 1.115507-5.71621 4.537657-5.478507 5.369561.237704.831903 16.314781 9.39673 16.314781 9.39673l6.69721 5.199399 6.248213-11.669341 5.206845-16.074649 2.920361-9.328666 2.39213-2.68478-1.101738-6.29978s-.988546-2.726376-1.795984-2.344456c-.807439.381919-3.773076 3.592311-6.553833 3.868352s-4.410726.623928-5.059695 0-.260342-1.327264-.814984-4.859074z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m206.57968 159.426789s-2.063872.060502-2.173292 2.525962c-.109419 2.46546-1.860126 2.291517-1.860126 2.291517l-8.134752 8.462729s-3.652337 8.765241-3.61838 9.12069c.033958.35545-.826303 1.837751-.633876 2.586465.192426.748713-.071689 3.025104-.754616 2.824691-.682926-.200413-1.811076.499142-1.795984 1.61465.015093 1.115507-5.71621 4.537656-5.478506 5.36956s16.31478 9.400512 16.31478 9.400512l6.693437 5.195617 6.248214-11.665559 5.210618-16.074649 2.916587-9.332447 2.395904-2.684781-1.101739-6.29978s-.988546-2.726375-1.795984-2.340674-3.773076 3.58853-6.553833 3.868352-4.414498.623928-5.063468 0c-.648969-.623928-.260342-1.312139-.814984-4.862855z"
            fill="#fff"
          />
          <path
            d="m206.651368 159.415444c-.965116-.095597-1.91897-.282989-2.848672-.559644-.996092-.378138-4.682387-.08319-4.682387-.08319s-4.233391.260915-5.014418 1.486082c-.781027 1.225168-4.150383 7.853928-5.304945 8.26988-1.154561.415952-7.980055 11.427332-9.376093 12.395365-1.396038.968034-7.410322 12.777286-7.410322 12.777286s4.444684-2.102448 6.478372.975596c.052823.079409.105646.158818.154696.24579 1.954453 3.433493 3.773076.786527 3.773076.786527s6.470825-5.906517 6.987737-6.935052c.516911-1.028536 4.34281-8.765241 5.327583-10.901721s9.32327-12.690313 9.602478-13.159204 2.312895-5.297715 2.312895-5.297715z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m206.651368 159.415444c-1.133643-.156091-2.254622-.39367-3.354264-.710899-.999865-.378138-4.68616-.08319-4.68616-.08319s-4.233391.260915-5.014418 1.482301-4.150384 7.857709-5.304945 8.269879c-1.154561.412171-7.980056 11.427332-9.376094 12.399147s-7.410321 12.777285-7.410321 12.777285 4.444684-2.102447 6.482145.975597c.04905.075627.101873.158818.150923.245789 1.954453 3.429713 3.773076.786527 3.773076.786527s6.474598-5.910297 6.987736-6.935052c.513139-1.024754 4.342811-8.76524 5.327583-10.90172.984773-2.13648 9.323271-12.690313 9.602479-13.162986.279207-.472672 2.82226-5.142678 2.82226-5.142678z"
            fill={fillColor}
          />
          <path
            d="m219.038377 159.808708s5.350221 3.891041 6.036921 5.070831c.6867 1.179791 7.693302 4.870419 7.693302 4.870419s2.641153 4.885543 2.24498 6.643885-.814984 3.433494-.471634 4.371276c.34335.937783.554642.93022.045277 2.166732-.509366 1.236511-.332031 1.357515.377307 2.469241.709339 1.111726-10.564612 4.537657-10.564612 4.537657s-1.509231.234445-1.671473.956689-8.806359 19.784184-10.055247 22.81307c-1.248888 3.028885-5.195526 15.125522-8.508287 15.295684-3.31276.170162-.754615.045377-.754615.045377s.509366-9.83159-1.528095-13.234832c-2.037461-3.403243 1.984637-16.535978 1.984637-16.535978s13.390647-38.615459 15.171539-39.470051z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m219.038377 159.808708s5.859587 4.046077 6.546286 5.222087c.6867 1.176009 7.712168 4.870418 7.712168 4.870418s2.641153 4.885544 2.24498 6.643886-.814985 3.437275-.471635 4.371276.554643.930219.045277 2.166731c-.509365 1.236511-.335803 1.357515.377308 2.473023.713111 1.115507-10.564613 4.537656-10.564613 4.537656s-1.50923.238227-1.671472.95669c-.162243.718462-8.825225 19.791746-10.081659 22.81685-1.256435 3.025105-5.195526 15.106616-8.508286 15.284341-3.312761.177725-.754616.045377-.754616.045377s.509366-9.83159-1.528095-13.234833c-2.037461-3.403242 2.018595-16.54354 2.018595-16.54354s12.85487-38.75537 14.635762-39.609962z"
            fill={fillColor}
          />
          <path
            d="m225.83746 198.730459s-11.870097 2.646966-12.239859 3.403242c-.369761.756277-10.187305 6.621198-5.037056 9.453452s13.243496-3.989357 13.243496-3.989357l6.414229-4.102798z"
            fill="#fec2be"
          />
          <path
            d="m231.142404 182.871348c.192427.056721 4.327718 2.684781 4.327718 2.684781s1.946908 6.481286 2.373265 8.069466c.426358 1.58818 1.509231 4.412871 1.437542 4.942264-.071688.529394 1.1772 3.475089-.814984 4.821261-1.992184 1.346171-4.082468 1.134414-5.04083 2.034383-.958361.899968-7.565017 3.78138-8.398867 4.008263s4.120199-9.873185-1.995957-11.427332c0 0 4.380541.41217 4.606926-.35545.226384-.76762.47918-2.771752-.339577-3.501558-.818758-.729807-4.35413-4.220021-4.35413-4.220021z"
            fill={fillColor}
          />
          <path
            d="m226.127986 149.776705c-.516327-.275622-.930408-.710502-1.180972-1.240293-.403719-.786527-.807439-1.746997-1.6677-1.947411-.482954-.117222-1.06778.02647-1.426223-.317636-.279207-.272259-.271661-.714681-.275434-1.104163.012543-.888733-.238256-1.761222-.720658-2.507055-.497078-.747635-1.341224-1.18847-2.237434-1.168447-1.226249.083191-2.29403 1.202479-3.501414.979378-.532004-.098316-1.041369-.457547-1.562054-.317636-.203083.063974-.390675.169566-.550869.310073-1.127237.888667-1.996258 2.063839-2.516641 3.403243-.498046 1.270544-.664062 2.646966-1.260208 3.89104-.237703.484017-.694246 1.002066-1.207384.850811-.799892-.238227-.377308-1.247856-.82253-1.690277-.18185-.142562-.400364-.230423-.630104-.253353-.312745-3.855428 1.641196-7.540907 5.004264-9.43893 3.363069-1.898023 7.520647-1.661715 10.648028.605211 3.127381 2.266925 4.65302 6.150176 3.907333 9.945445z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m208.104003 150.351475c.513138.151255.96968-.378138 1.207384-.847029.596146-1.228949.754615-2.620497 1.260207-3.891041.520783-1.340204 1.391258-2.515581 2.520415-3.403242.158682-.141499.344992-.24838.547096-.313855.520685-.13613 1.033823.21932 1.562054.317636 1.207384.226883 2.263845-.896187 3.501414-.979378.896936-.019189 1.741238.423154 2.237434 1.172228.484629.743409.735662 1.615394.720658 2.503274 0 .378138 0 .831904.279207 1.104164.354669.347887.939496.204194 1.426223.317635.860261.204195 1.260207 1.160884 1.667699 1.947412.407493.786527 1.22625 1.610868 2.045008 1.270543.245249-.102097.445223-.30251.698019-.378138.464088-.155036 1.01873.098316 1.433768-.158818.528231-.325198.377308-1.134414.033958-1.675151-.34335-.540738-.754615-1.134414-.53955-1.712966.138624-.280521.33242-.530051.569735-.733588 1.258485-1.457596 1.162449-3.646377-.218839-4.987641-.335803-.30251-.728203-.536956-1.056461-.847029-.660288-.620146-1.011184-1.489864-1.50923-2.268828-.60605-.940138-1.430831-1.718722-2.40345-2.268829-.424479-.26227-.900868-.428728-1.396038-.487798-.682926-.052939-1.354534.204195-2.037461.27226-2.286484.230664-4.252256-1.580617-6.48969-2.094885-.513656-.168278-1.075141-.101913-1.535642.181506-.445223.347887-.53955.971815-.754615 1.512552-.448996 1.157103-1.535642 1.966318-2.690204 2.412521-1.331895.510487-3.01846.786527-3.573102 2.098666-.482954 1.134415.143376 2.43521-.10942 3.630126-.1962.934001-.894219 1.663807-1.433769 2.450335-.539549.786527-.935722 1.845313-.467861 2.677217.289298.446912.719714.783748 1.222477.956689.62633.257134 2.022368.121004 2.444953.536956.422584.415952.037731 1.455832.837623 1.686496z"
            fill="#9a5e7f"
          />
          <path
            d="m230.455705 194.234397c.226384.022689 4.350356.756276 5.320037 2.147824.96968 1.391549-5.320037-2.147824-5.320037-2.147824z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m228.391832 189.825307s4.497506 1.020973 5.018191 1.455832c.520684.434859-5.018191-1.455832-5.018191-1.455832z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m229.870878 178.696704s3.308987 1.45205 3.686295 2.352019-3.686295-2.352019-3.686295-2.352019z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m187.582243 216.294972c.34335.242008 8.470555 6.284654 7.806494 6.503975-.664062.21932-7.806494-6.503975-7.806494-6.503975z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m187.521874 220.076352s4.761621 2.306643 3.965502 3.270895-3.965502-3.270895-3.965502-3.270895z"
            fill="#000"
            opacity=".1"
          />
          <g
            fill="#000"
            opacity=".1"
            transform="translate(203.406489 138.39475)"
          >
            <path d="m2.26765307 3.13854592c.21506533-1.02475415-.21506533-2.13269867-.03773076-3.13854592v.0189069c-.47540756 1.10416315.12451151 2.39361394-.09809997 3.5734047.05653782-.14763745.1019422-.29931849.13583073-.45376568z" />
            <path d="m25.4494316 6.71195061c-.0342925.09979705-.0521338.20452642-.0528231.31007321.1418057-.19083574.2995886-.36920665.4716345-.53317466.4017723-.44005982.6769146-.98110072.796119-1.56549158-.1445928.39035699-.3637475.74871208-.645196 1.05500519-.237315.20353624-.4311104.45306637-.5697344.73358784z" />
            <path d="m25.9587968 10.1000677c-.4150383.2571338-.9734536 0-1.4375419.1588179-.2527961.0869718-.4527691.2836036-.6980191.3781381-.8187574.3403243-1.641288-.4802353-2.0450071-1.26676251-.4037191-.78652717-.8074383-1.74699785-1.6676996-1.9511924-.4829537-.11344142-1.0715535.03025104-1.4262227-.31763597-.2792076-.26847803-.2716614-.71089956-.2792076-1.10038177.0143476-.88843534-.2351847-1.76108821-.7168844-2.50705535-.4998408-.74696476-1.3439408-1.18845793-2.2412071-1.172228-1.2224766.08319038-2.2902571 1.20626042-3.4976414.98315897-.5320037-.10209728-1.045142-.45754706-1.5658265-.32141736-.2014554.06693776-.38748338.17365709-.54709602.3138546-1.12915739.88766102-1.99963245 2.06303813-2.52041472 3.40324256-.1444763.36264813-.27040898.73244302-.37730759 1.10794452.06414229-.20041317.13205766-.40082634.21129225-.59745813.52078227-1.34020444 1.39125733-2.51558155 2.52041472-3.40324257.15868227-.14149908.34499186-.24837999.54709596-.31385459.5206845-.1361297 1.0338229.21932008 1.5620535.31763597 1.2073843.22688284 2.2638455-.89618721 3.5014144-.97937758.8969364-.01918974 1.7412378.42315348 2.2374341 1.17222799.4846293.74340854.7356617 1.61539407.7206575 2.50327398 0 .37813806 0 .83190374.2792076 1.10416314.3546691.34788702.9394959.20419456 1.4262227.31763597.8602613.20419456 1.2602073 1.16088386 1.6676995 1.94741103.4074922.7865272 1.2262497 1.6108681 2.0450072 1.2705439.2452499-.1020973.445223-.3025105.698019-.3781381.4640884-.1550366 1.0187305.0983159 1.4337689-.158818.2271412-.1491266.3568222-.4090596.3395768-.68064847-.0458733.06653546-.103399.12418787-.1697884.17016217z" />
            <path d="m6.0558213 10.5916471c-.23393071.4840168-.69424597.9982845-1.20738429.8470293-.7998921-.2344456-.3773076-1.2440742-.81875748-1.68649576-.44144988-.44242154-1.8186226-.27982217-2.4449532-.53695605-.50220286-.1739739-.93231427-.51057174-1.2224766-.9566893-.20821951-.39325769-.26463265-.84959452-.15846919-1.28188803-.27170739.56643075-.27170739 1.22594366 0 1.79237441.28929795.44691207.71971418.78374845 1.2224766.9566893.6263306.25713388 2.0223687.12100418 2.4449532.53695603.4225845.4159519.01886538 1.4520502.81875748 1.6864958.51313832.1512552.96968051-.3781381 1.20738429-.8470293.24233762-.5262882.43803342-1.0729118.58482677-1.63355641-.11420394.38441101-.25671445.75979851-.42635758 1.12307001z" />
          </g>
          <path
            d="m192.626845 168.006741s-3.248618 4.859074-2.859991 5.876266c.388627 1.017191 2.859991-5.876266 2.859991-5.876266z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m193.102253 183.839382s1.724296.722244 2.354399 1.399111c.630104.676867-2.354399-1.399111-2.354399-1.399111z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m196.890421 188.792991s3.682522.892405 3.995687 1.470957c.313166.578551-3.995687-1.470957-3.995687-1.470957z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m197.531844 193.844915s3.331626.43864 3.708934 1.731872c.377307 1.293233-3.708934-1.731872-3.708934-1.731872z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m308.645157 251.325682c-.63765 6.072897-4.94273 5.112427-4.94273 5.112427l-.803665-.071847c-.863142-1.361079-1.304313-2.94805-1.267753-4.560345 0-2.113791.671607-3.981793 1.701657-5.104864 2.988276.620147 5.595472 1.928505 5.312491 4.624629z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m185.461774 171.757871c-7.278263 0-13.175581 7.990057-13.175581 17.844335s5.897318 17.840554 13.175581 17.840554c7.278264 0 13.179354-7.990057 13.179354-17.840554s-5.897317-17.844335-13.179354-17.844335zm-1.860126 31.956448c-5.546422 0-10.040155-5.793076-10.040155-12.943666 0-7.150591 4.493733-12.939885 10.040155-12.939885 5.546421 0 10.043928 5.793075 10.043928 12.939885 0 7.146809-4.493734 12.943666-10.043928 12.943666z"
            fill={fillContrast}
          />
          <path
            d="m186.099424 195.088989 6.165206 6.069116 2.229888-5.433844-8.927098-5.218305z"
            fill={fillContrast}
          />
          <path
            d="m195.188764 134.995288 5.365314.654179 1.992184 2.370926-3.018461 13.61297-6.414229 21.932008-4.210753 15.057457-2.958091 9.143379-1.886538 12.100418-1.886538 8.319037-5.659614 5.672071-11.507882-13.61297-1.886538-4.537657-4.527691-9.264382 11.696536-5.483002 12.828458-1.134415 6.036921-15.50366 4.904999-17.961558z"
            fill={fillColor}
          />
          <path
            d="m86.618504 199.879999-7.0141481 59.012226 88.3201611-3.728442-10.202397-28.972938-17.005253-11.079445 38.900412.639053.211293-16.18809-15.729954-3.410806-31.671199-2.556213-23.808109-1.062568-22.7441019 7.453101"
            fill="#dadff6"
          />
          <path
            d="m86.618504 199.879999-7.0141481 59.012226 88.3201611-3.728442-10.202397-28.972938-17.005253-11.079445 38.900412.639053.211293-16.18809-15.729954-3.410806-31.671199-2.556213-23.808109-1.062568-22.7441019 7.453101"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m207.285245 258.68803c0 14.664194-4.863495 28.012468-18.352241 26.552855-17.012799-.378138-18.348468-11.888661-18.348468-26.552855s8.213986-25.577259 18.348468-25.577259 18.352241 10.913065 18.352241 25.577259z"
            fill="#000"
          />
          <path
            d="m207.390891 258.7145c0-11.344142-4.923864-20.457269-11.851231-23.989079-8.896913 1.694059-15.733727 11.949163-15.733727 25.33525 0 12.017228.897992 21.932008 10.587251 25.308781 12.46247.442421 16.997707-12.493682 16.997707-26.654952z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m224.618756 235.674548-5.187979 5.955674 9.338363-1.607087 6.98019-6.428347 6.225575-12.478556 8.772402-5.388467 21.506533 2.93057 19.902975.756276 7.346179-6.538007-8.195121-1.119289-8.300767-.189069-20.846244-.472673-24.807975-.661741-5.093652 13.61297-3.867403 9.358917z"
            fill={fillColor}
          />
          <path
            d="m295.997806 259.954793c-.426357.639053-14.337688 2.771752-14.337688 2.771752l-38.485375 7.029586-66.096744.956689-7.757444-6.606072-4.074922.726026-.166015.030251-54.43794 9.684115-.886672-.124785-14.8357349-2.121355-77.4876603-11.068101.8678074-11.272295.5131384-6.65523 1.0602343-13.813384.7546152-3.622562 6.9009559-.635272 3.2222068-.294948 50.291329-4.624629 6.5764714-.60502 3.6862951-.336543 35.9234557-4.915795 52.396706 1.278107.211292-16.191872 20.725506-63.905333c4.569195.756276 4.463549 3.83432 4.463549 3.83432l-17.646676 60.184454-.215066 36.962996c36.693164 3.713315 37.87791-4.29943 43.6809-1.599524l7.017922-22.472745 61.640741.321417c2.463819 2.987291-3.505188 47.085752-3.505188 47.085752z"
            fill="#dadff6"
          />
          <path
            d="m143.056174 226.402602 19.555852 42.075423 6.587791 2.128917 1.596011-6.817829-7.33486-23.327338-7.546151-13.525998z"
            fill="#dadff6"
          />
          <path
            d="m143.056174 226.402602 19.555852 42.075423 6.587791 2.128917 1.596011-6.817829-7.33486-23.327338-7.546151-13.525998z"
            fill="#000"
            opacity=".15"
          />
          <ellipse
            cx="130.325816"
            cy="272.735859"
            fill="#000"
            rx="35.417864"
            ry="40.264141"
          />
          <path
            d="m142.961847 234.986336c-18.533349 1.293232-33.203068 18.785899-33.203068 40.180951 0 17.246877 9.538336 31.960229 22.944074 37.692802 18.533349-1.293232 33.203069-18.785899 33.203069-40.180951 0-17.246877-9.538336-31.960229-22.944075-37.692802z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m35.3914522 202.330333-1.7544803 8.292568-5.365314 25.376845-23.06481312-2.238577s-1.38094579-4.257835 2.23366095-5.857359c0 0 1.18474584-14.418404 5.44832167-18.959842.4556215-.518158 1.0288964-.918907 1.6714726-1.168447z"
            fill="#dadff6"
          />
          <path
            d="m33.6369719 210.622901-5.365314 25.376845-23.06481312-2.238577s-1.38094579-4.257835 2.23366095-5.857359c0 0 1.18474584-14.418404 5.44832167-18.959842z"
            fill="#fff"
            opacity=".1"
          />
          <path
            d="m87.3655731 204.572692c2.9731838 4.998985-4.2371643 51.120485-4.2371643 51.120485l-56.6640543-9.374043 2.0185957-40.37002c1.1696535-7.241343 5.4219101-8.092154 5.4219101-8.092154 19.9973024-10.118975 65.892998-12.251673 65.892998-12.251673 41.8811427 1.595742 80.0307137 13.953294 80.0307137 13.953294-47.612445-7.347222-92.4629989 5.014111-92.4629989 5.014111z"
            fill="#dadff6"
          />
          <path
            d="m83.1284088 255.693177-56.6640543-9.374043 2.0185957-40.37002c1.1696535-7.241343 5.4219101-8.092154 5.4219101-8.092154s41.3415929-3.94398 53.4607128 6.715732c2.9731838 4.998985-4.2371643 51.120485-4.2371643 51.120485z"
            fill="#000"
            opacity=".2"
          />
          <path
            d="m77.125445 253.031085-47.3671952-7.99762 1.6790188-34.444597c.9772267-6.178775 4.5276911-6.904801 4.5276911-6.904801s34.5689217-3.365428 44.6996305 5.725011c2.5015494 4.269178-3.5391452 43.622007-3.5391452 43.622007z"
            fill="#dadff6"
          />
          <ellipse
            cx="73.227858"
            cy="224.6972"
            fill="#000"
            opacity=".1"
            rx="6.482144"
            ry="11.824377"
          />
          <ellipse
            cx="73.227858"
            cy="224.379564"
            fill="#afb6d4"
            rx="6.482144"
            ry="11.824377"
          />
          <path
            d="m74.0730266 215.644574s-2.6411532.423515-1.2752997 3.940199 1.5922381 5.324184 1.5922381 5.324184 2.6411531 1.387767 2.5505993-3.195267c-.0905538-4.583033-2.8675377-6.069116-2.8675377-6.069116z"
            fill="#f0f0f4"
          />
          <ellipse
            cx="38.474055"
            cy="220.012069"
            fill="#000"
            opacity=".1"
            rx="6.05956"
            ry="11.049194"
          />
          <ellipse
            cx="38.474055"
            cy="219.690652"
            fill="#afb6d4"
            rx="6.05956"
            ry="11.049194"
          />
          <path
            d="m39.3229973 210.955662s-2.6411531.427296-1.2752997 3.94398c1.3658535 3.516684 1.5960112 5.324184 1.5960112 5.324184s2.6411531 1.383986 2.5505993-3.195266-2.8713108-6.072898-2.8713108-6.072898z"
            fill="#f0f0f4"
          />
          <path
            d="m65.7722596 214.684104c-.4225846 4.367494-2.5505994 36.747457-2.5505994 36.747457l-3.6070606-.605021-2.0035033-.32898-2.6713377-.449985-.3244846-.052939-10.5231087-1.758342 2.0789648-34.34628c.1448737-2.291991 2.0629529-4.064373 4.3541296-4.023389.1068294-.005654.2138821-.005654.3207115 0 .7282036.064283 1.5092304.139911 2.3279878.230664.3433499.037814.694246.075628 1.0451421.121004 1.0111843.121004 2.0563263.268478 3.0788299.434859.5206845.090753 1.0338228.185288 1.5431881.283604.8564882.170162 1.6865649.359231 2.4524993.574769.5169114.143693 1.0111844.298729 1.4639535.468892 1.9016303.688211 3.1429722 1.576835 3.0146877 2.703687z"
            fill="#afb6d4"
          />
          <path
            d="m50.5252597 209.866625-2.0600994 38.570082-1.1696536-.105878 2.0412341-38.346981c.388715-.094814.7888191-.134276 1.1885189-.117223z"
            fill="#cdd2e9"
          />
          <path
            d="m54.2191011 210.214512-1.9280418 38.978471h-1.8073034l2.6902031-39.103257c.3433499.041595.694246.079409 1.0451421.124786z"
            fill="#cdd2e9"
          />
          <path
            d="m58.8411191 210.932974-3.0410992 39.114601h-1.1734266v-.052939l2.6675646-39.326359c.5244576.071847 1.0375959.166381 1.5469612.264697z"
            fill="#cdd2e9"
          />
          <path
            d="m62.7537988 211.976635-3.1278799 38.849905v.075627l-2.0185957-.215538v-.189069l3.6674298-38.989816c.5357768.143692 1.0300498.298729 1.4790458.468891z"
            fill="#cdd2e9"
          />
          <path
            d="m19.529441 242.061299s-3.9051336-20.211479 5.0219641-21.251359c8.9270976-1.039879 38.2627629 1.134415 37.3836362 9.426982-.8791267 8.292568-1.8223956 20.929942-1.8223956 20.929942l-6.0557869-1.357516s4.5276911-19.012781-2.5505993-19.731244c-7.0782905-.718462-24.4721705-2.718812-24.4721705-2.718812s-4.7050257-.797872-1.9921841 15.881798z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m19.529441 243.978459s-3.9051336-21.489586 5.0219641-22.529465c8.9270976-1.03988 38.2627629 1.134414 37.3836362 9.426982-.8791267 8.292567-1.8223956 20.929941-1.8223956 20.929941l-6.0557869-1.357515s4.5276911-19.012782-2.5505993-19.731244c-7.0782905-.718463-24.4834897-2.699906-24.4834897-2.699906s-4.7050257.480235-1.9921841 17.178812z"
            fill="#afb6d4"
          />
          <path
            d="m177.077999 270.71282-7.86309-.105878c-5.738848-25.33525-15.201723-41.114952-15.201723-41.114952-3.199568-1.705402-38.059017-1.474738-38.059017-1.474738-3.614606.639053-4.569195 12.145794-4.569195 12.145794s3.082603 2.646967.105647 4.367495c-1.328123.756276-5.704891.90375-10.745721.642835-6.2557596-.325199-13.5453423-1.278107-17.310872-2.454116-6.7915367-2.132699-1.3847189-6.072898-1.3847189-6.072898s.9583613-1.278106 1.5960111-8.319037c.4376903-4.104519 1.7612076-8.064455 3.8787221-11.605057.2942999-.487798.4791806-.756276.4791806-.756276.3568631-.341241.7791864-.606256 1.241342-.778965 9.0101053-3.78138 53.1739591-.181506 53.1739591-.181506l16.367603 5.222087c.452769.181506 1.150788 1.338608 2.01105 3.187704 5.172887 11.113477 16.280822 47.297508 16.280822 47.297508z"
            fill="#dadff6"
          />
          <path
            d="m177.077999 270.71282-7.86309-.105878c-5.738848-25.33525-15.201723-41.114952-15.201723-41.114952-3.199568-1.705402-38.059017-1.474738-38.059017-1.474738-3.614606.639053-4.569195 12.145794-4.569195 12.145794s3.082603 2.646967.105647 4.367495c-1.328123.756276-5.704891.90375-10.745721.642835-6.2557596-.325199-13.5453423-1.278107-17.310872-2.454116-6.7915367-2.132699-1.3847189-6.072898-1.3847189-6.072898s.9583613-1.278106 1.5960111-8.319037c.4376903-4.104519 1.7612076-8.064455 3.8787221-11.605057.2942999-.487798.4791806-.756276.4791806-.756276.3568631-.341241.7791864-.606256 1.241342-.778965 9.0101053-3.78138 53.1739591-.181506 53.1739591-.181506l16.367603 5.222087c.452769.181506 1.150788 1.338608 2.01105 3.187704 5.172887 11.113477 16.280822 47.297508 16.280822 47.297508z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m160.797177 223.41153c-15.092304-5.883828-56.747062-2.760408-56.747062-2.760408-4.4220452-3.78138-12.7416776-4.038514-16.5260727-3.936417.2942999-.487798.4791806-.756276.4791806-.756276.3568631-.34124.7791864-.606256 1.241342-.778964 9.0101053-3.781381 53.1739591-.181507 53.1739591-.181507l16.367603 5.222087c.452769.185288 1.150788 1.34239 2.01105 3.191485z"
            fill="#dadff6"
          />
          <path
            d="m106.495068 222.246865c-.954588 3.301145-4.878587 16.513289-4.878587 16.513289-.410614 2.112988-.699106 4.247982-.864035 6.394315-6.2557594-.325199-13.5453421-1.278107-17.3108719-2.454116-6.7915367-2.132699-1.3847188-6.072898-1.3847188-6.072898s.9583612-1.278106 1.5960111-8.319037c.468147-4.404104 1.9607765-8.636702 4.3579027-12.357552.356863-.34124.7791863-.606256 1.2413419-.778964 5.9010908 1.406673 17.967388 4.57547 17.242957 7.074963z"
            fill="#dadff6"
          />
          <path
            d="m106.495068 222.246865c-.954588 3.301145-4.878587 16.513289-4.878587 16.513289-.410614 2.112988-.699106 4.247982-.864035 6.394315-6.2557594-.325199-13.5453421-1.278107-17.3108719-2.454116-6.7915367-2.132699-1.3847188-6.072898-1.3847188-6.072898s.9583612-1.278106 1.5960111-8.319037c.468147-4.404104 1.9607765-8.636702 4.3579027-12.357552.356863-.34124.7791863-.606256 1.2413419-.778964 5.9010908 1.406673 17.967388 4.57547 17.242957 7.074963z"
            fill="#fff"
            opacity=".2"
          />
          <path
            d="m116.222058 138.364499c-4.225845.639053-6.05956 9.426981-6.05956 9.426981l-11.4776971 38.42639 81.1437711 13.340711 20.725506-63.905332c-19.050261-8.632892-84.33202 2.71125-84.33202 2.71125zm65.274213 41.062012s-.47918 3.675502-3.588195 3.996919l-52.607998-2.060852-10.790997-.427296-3.61838-.139911h-.256569s-3.988141.718462-3.350491-2.646967c0 0 4.384314-31.952666 12.11912-34.350062 0 0 .803665-.170162 2.211022-.434858 2.211023-.419734 5.901091-1.077694 10.247674-1.678933 1.946908-.268478 4.025872-.525612 6.165207-.756276 5.844494-.597459 12.126666-.918876 17.325964-.415952 0 0 38.738171-3.596093 35.949868 5.033017.007546.011344-8.123433 31.245548-9.798679 33.881171z"
            fill="#dadff6"
          />
          <path
            d="m110.898248 180.795371h-.25657s-3.988141.718462-3.350491-2.646967c0 0 4.384314-31.952666 12.11912-34.350062 0 0 .803665-.170162 2.211022-.434858-2.807168 5.490564-11.817273 24.287807-10.723081 37.431887z"
            fill="#dadff6"
          />
          <path
            d="m110.898248 180.795371h-.25657s-3.988141.718462-3.350491-2.646967c0 0 4.384314-31.952666 12.11912-34.350062 0 0 .803665-.170162 2.211022-.434858-2.807168 5.490564-11.817273 24.287807-10.723081 37.431887z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m118.04068 259.610687c-.942761 1.757686-2.815007 2.810103-4.803125 2.699906l-1.626196-.071847-15.3224614-.661741-5.5237831-.238227-5.1011987-.423515-67.3644976-10.966004.5131384-6.655229 7.7461248 1.111725 3.2071146.461329 47.559622 6.806485 6.259533.922657 3.0373261.434859 12.8624159-.094535 13.92265-.102097c.702569-.013237 1.400611.115362 2.052553.378138 1.195778.475487 2.162219 1.395288 2.69775 2.567557.57823 1.221339.5347 2.646921-.116966 3.830539z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m118.04068 260.24974c-.942761 1.757686-2.815007 2.810103-4.803125 2.699906l-22.4724405-.971815-5.1011987-.427296-71.8393656-11.680685-5.65961389-.918875-3.06373766-.514268c-6.05578686-1.278106-4.24848349-7.351004-4.24848349-7.351004.4225845-2.771752 10.84004714-5.327965 14.23958854-5.218305 2.286484.071846 2.6034224 3.599874 2.5656916 5.910298 0 1.134414-.1207384 1.970099-.1207384 1.970099l3.3618107.484017 65.7232095 9.4232 26.7888389-.196631c2.028006-.036297 3.88814 1.124589 4.750303 2.964602.575774 1.220898.530849 2.644755-.120739 3.826757z"
            fill="#afb6d4"
          />
          <path
            d="m10.2023973 239.716843s2.8713108 3.512903 7.3348596 4.046078c0 0-1.8073034-3.940199-7.3348596-4.046078z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m9.45910135 249.624061s-9.45910135-.215539-9.45910135 4.915795c0 5.131333 5.95391381 5.967018 5.95391381 5.967018l84.49426229 16.290188 24.0194009.423515s8.395094-6.70817-.320711-9.691679l-24.2269205.627709-80.56649028-14.804105s2.12424178-2.877631.10564613-3.728441z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m114.467577 277.848286-24.0194009-.423515-75.1294878-14.49025-5.49737166-1.062568-3.86740283-.756277s-5.95391381-.854592-5.95391381-5.967018c0-3.667939 4.8748141-4.594378 7.62538645-4.825042 1.08287279-.086972 1.8337149-.071846 1.8337149-.071846 2.01859565.850811-.10564613 3.72466-.10564613 3.72466l2.93167998.540737 77.6348103 14.278493 24.2306935-.639053c8.712032 2.968384.316938 9.691679.316938 9.691679z"
            fill="#afb6d4"
          />
          <path
            d="m16.5788956 245.468323 4.9955525-2.238577 2.5505994-.105879-.2112923 21.516056-7.8630902-1.595742-3.2976684-2.128918-1.592238-8.946746s.6376498-3.728442.9545882-4.046078 4.4635488-2.454116 4.4635488-2.454116z"
            fill="#dce0ed"
          />
          <path
            d="m16.5788956 245.468323 4.9955525-2.238577 2.5505994-.105879-.2112923 21.516056-7.8630902-1.595742-3.2976684-2.128918-1.592238-8.946746s.6376498-3.728442.9545882-4.046078 4.4635488-2.454116 4.4635488-2.454116z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m15.3186883 262.934521.0905538.10966-5.52378317-1.06635-.06414229-.105878c-2.90904154-4.707819-3.16183763-8.519451-2.19593019-11.544556 1.08287279-.086971 1.8337149-.071846 1.8337149-.071846 2.01859565.850811-.10564613 3.72466-.10564613 3.72466l2.93167998.540738c-.1961999 4.22002 2.4940032 7.748049 3.0335531 8.413572z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m23.4911707 243.142774c-.9357228.357971-1.7997572.736109-2.5921031 1.134414-3.576876 1.72431-5.7841254 3.660377-7.0745174 5.622913l-5.65961389-.918875c2.44872629-5.097301 8.30076699-7.426632 8.30076699-7.426632l1.1847459.268478z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m17.0995801 241.528125s-15.51488821 6.178776-6.5877906 20.449706l5.5275563 1.06635s-10.94192022-12.56931 8.0743824-19.920314z"
            fill="#dce0ed"
          />
          <path
            d="m54.0983626 248.451833 5.7388485-.211758-.9583613 23.111799-9.2478091-1.701622-3.9315451-1.917159-1.8073033-4.583034-1.2752997-4.579252 3.082603-4.155737 3.5089606-2.340675z"
            fill="#dce0ed"
          />
          <path
            d="m54.0983626 248.451833 5.7388485-.211758-.9583613 23.111799-9.2478091-1.701622-3.9315451-1.917159-1.8073033-4.583034-1.2752997-4.579252 3.082603-4.155737 3.5089606-2.340675z"
            fill="#000"
            opacity=".1"
          />
          <ellipse
            cx="53.460713"
            cy="260.382089"
            fill="#dce0ed"
            rx="2.761892"
            ry="4.685131"
          />
          <path
            d="m33.3992681 273.454321c-.796119-4.072547-3.9051336-4.953608-3.9051336-4.953608s-5.9803253-1.754561-6.1387945 4.893106c0 0 .0792346 4.076329 2.7920762 5.354435l.1584692 4.537657s.2377037 4.235146-2.1544264 3.83432-2.0714187-4.159519-2.0714187-4.159519-1.2752996-3.993138-4.3843142-1.91716c0 0-.7168844 2.238578.8791267 3.357866.9281767.650398.9621343 1.981444.8300767 2.979728-.1878971 1.247246.1757821 2.514642.996092 3.471308.9340749 1.121753 2.4011031 1.648498 3.8334452 1.376422 1.2870387-.253341 2.4543873-.926044 3.3203068-1.913378 1.4588592-1.587866 2.278844-3.661201 2.3015763-5.819545l.1169654-5.846015s4.2220719-1.119288 3.4259529-5.195617zm-4.9049987 4.114143c-1.8754311 0-3.3957683-1.523684-3.3957683-3.403243s1.5203372-3.403243 3.3957683-3.403243 3.3957683 1.523684 3.3957683 3.403243c-.0083014 1.872175-1.5239146 3.386055-3.3919952 3.388117z"
            fill="#dce0ed"
          />
          <path
            d="m27.1057775 266.742371c-.3905515.163495-.6946523.483835-.8381437.8829s-.1131851.840178.0835285 1.215766c.6263306 1.176009 1.3771727 2.696124 1.3054842 3.096951-.1207384.676867 1.3960381.121004 1.5922381-.041595.1961999-.1626 2.9505454 0 3.1090145-1.890691.1584692-1.89069-1.4714996-2.87763-1.4714996-2.87763l.6376499-4.114143-3.773076-.317635.0415039 3.75491z"
            fill="#636780"
          />
          <path
            d="m27.1057775 266.742371c-.3905515.163495-.6946523.483835-.8381437.8829s-.1131851.840178.0835285 1.215766c.6263306 1.176009 1.3771727 2.696124 1.3054842 3.096951-.1207384.676867 1.3960381.121004 1.5922381-.041595.1961999-.1626 2.9505454 0 3.1090145-1.890691.1584692-1.89069-1.4714996-2.87763-1.4714996-2.87763l.6376499-4.114143-3.773076-.317635.0415039 3.75491z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m28.1396003 266.666743s1.2752996 4.393964.7168844 4.537657c-.5584153.143692-.7168844-4.537657-.7168844-4.537657z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m29.5733691 265.626864s1.2752997 4.393964.7168844 4.537656c-.5584152.143693-.7168844-4.537656-.7168844-4.537656z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m44.8543266 252.392031-2.1280148 13.208363s-2.6411532-.359231-4.0824682-.673086c-.3177493-.044032-.6261785-.13983-.9130843-.283603-.0754616-.075628-.2301577-.068065-.4376768-.02647-.7093383.143692-1.9695457.729806-2.2147956.234445-.0176292-.038045-.0419078-.072622-.0716885-.102097-.249023-.272259-.7319767-.075627-1.1998381 0-.254767.066146-.5251912.030914-.7546152-.098316-.3773076-.264696-1.1885189.158818-1.837488.298729-.4112652.090754-.7546151.071847-.9281766-.298729-.1264655-.244372-.362206-.413128-.6338768-.453765-.6112383-.155037-1.4677265-.049158-1.9619995-.155037-.1961999-.037814-.3282576-.113441-.3773076-.24579-.0980999-.287385-.645196-.423514-1.2300227-.536956-.7131114-.136129-1.4790458-.238227-1.5356419-.525612 0-.098316-.0867808-.139911-.1924269-.143692-.3952681.060254-.7842424.156446-1.1621074.287385-.3169384.08319-.5848267.08319-.6602883-.143693-.0754615-.226883-.448996-.226883-.8678074-.124785-.3358038.08319-.7093383.215538-.9960921.283603-.2867537.068065-.4452229.068065-.4754075-.05672-.1056462-.423515-1.486592.536956-1.8035303-.317636-.3169384-.854592-4.6861603-6.519101.9734536-13.854979 0 0 1.5092303.105879 2.68643.317636.3902602.052367.7712727.159286 1.1319228.317636.4037191.230664 1.2677535.181506 2.0487802.238227.3928158.005256.7795145.098268 1.1319228.272259.1401265.076594.2524109.195746.3207115.340325.1773345.404607.5848267.487798 1.0300497.465109.6036921-.037813 1.2752996-.264696 1.5092304-.143692h.0226384c.445223.19285 2.1129225 0 2.3959032.283604l.0226385.026469c.1207384.177725.7546152 0 1.441315-.098316.5169114-.068065 1.0375959-.075627 1.3205766.207976.2921008.232277.6626559.342062 1.0338228.306292.4520697-.03296.9063986-.015204 1.3545342.052939.1033969.030542.1961958.089488.2678884.170162.2678884.336543.9168575.291167 1.5092304.321418.2961909-.012445.5896674.061086.845169.211757.0916899.06397.1958414.107784.3056191.128567.8149844.189069 2.5619186-.128567 2.5619186-.128567z"
            fill="#636780"
          />
          <path
            d="m21.665002 262.601759c-.3358038.08319-.7093383.215539-.9960921.283604-4.3163988-6.711951-.6829267-11.809252 1.3620804-13.904137.3902602.052367.7712727.159286 1.1319228.317636-4.3428104 5.014111-2.3279878 11.276077-1.4979111 13.302897z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m24.3589782 262.582852c-.3952681.060255-.7842424.156447-1.1621074.287385-3.6938413-6.54557.1056461-11.442458 2.0261418-13.329367.3928158.005256.7795145.098268 1.1319227.27226-4.1315181 4.530094-2.9052684 10.168132-1.9959571 12.769722z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m27.6906042 264.034902c-.1961999-.037814-.3282576-.113441-.3773076-.245789-.0980999-.287385-.645196-.423515-1.2300227-.536957-3.2410722-5.929204-.3433499-10.485768 1.6224226-12.633592.6036922-.037814 1.2752997-.264697 1.5092304-.143693h.0226385c-4.5578758 5.146459-2.3506263 11.650434-1.5469612 13.560031z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m31.2184302 264.942434c-.4112653.090753-.7546152.071846-.9281767-.298729-.1264654-.244372-.3622059-.413129-.6338767-.453766-3.7730759-6.606072.0754615-11.544555 1.9959571-13.423901l.0226385.026469c.1207384.177725.7546152 0 1.441315-.098316-5.3728601 5.433844-2.6109685 12.648719-1.8978572 14.248243z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m34.9990523 264.745802c-.249023-.27226-.7319767-.075628-1.1998381 0-3.9390913-6.556914-.3207115-11.510523 1.6714726-13.533561.4520697-.032961.9063986-.015204 1.3545342.052939-4.5993795 4.95739-2.7015223 11.276077-1.8261687 13.480622z"
            fill="#000"
            opacity=".1"
          />
          <path
            d="m38.6438436 264.927308c-.3177493-.044032-.6261785-.13983-.9130843-.283603-.0754616-.075628-.2301577-.068065-.4376768-.02647-3.4900953-5.989707-.7055652-10.614336 1.2979381-12.856694.2961909-.012445.5896674.061086.845169.211757.0916899.06397.1958414.107784.3056191.128567-3.8183528 4.93092-1.890311 10.875251-1.0979651 12.826443z"
            fill="#000"
            opacity=".1"
          />
          <ellipse
            cx="141.675228"
            cy="274.6568"
            fill="#6c6f7a"
            rx="17.322192"
            ry="25.562133"
          />
          <ellipse
            cx="141.090401"
            cy="275.027376"
            fill="#000"
            opacity=".1"
            rx="12.594527"
            ry="20.718185"
          />
          <ellipse
            cx="141.090401"
            cy="274.388322"
            fill="#f0f0f4"
            rx="12.594527"
            ry="20.718185"
          />
          <ellipse
            cx="143.373112"
            cy="260.487967"
            fill="#636780"
            rx="1.486592"
            ry="2.556213"
          />
          <ellipse
            cx="149.327026"
            cy="282.858615"
            fill="#636780"
            rx="1.486592"
            ry="2.556213"
          />
          <ellipse
            cx="133.276361"
            cy="272.206466"
            fill="#636780"
            rx="1.486592"
            ry="2.556213"
          />
          <ellipse
            cx="137.634264"
            cy="287.11645"
            fill="#636780"
            rx="1.486592"
            ry="2.556213"
          />
          <path
            d="m268.469444 227.359292s12.451151 33.234554 11.798409 35.310532c0 0 5.259668 3.195266 6.534967 2.397395 1.2753-.797871.162243-15.50366.162243-15.50366l-2.39213-12.939885-2.712842-7.66864z"
            fill="#dadff6"
          />
          <path
            d="m268.469444 227.359292s12.451151 33.234554 11.798409 35.310532c0 0 5.259668 3.195266 6.534967 2.397395 1.2753-.797871.162243-15.50366.162243-15.50366l-2.39213-12.939885-2.712842-7.66864z"
            fill="#000"
            opacity=".15"
          />
          <ellipse
            cx="151.451268"
            cy="269.011199"
            fill="#636780"
            rx="1.486592"
            ry="2.556213"
          />
          <ellipse
            cx="143.373112"
            cy="275.186194"
            fill="#636780"
            rx="4.357903"
            ry="6.072897"
          />
          <path
            d="m282.346818 271.77917c0 19.235883-6.376499 36.747457-24.072225 34.830297-22.317744-.480236-24.072224-15.594414-24.072224-34.830297s10.768359-33.552191 24.064678-33.552191c13.29632 0 24.079771 14.312526 24.079771 33.552191z"
            fill="#000"
          />
        </g>
        <path d="m55.277498 306.080427h300v1h-300z" fill="#000" />
        <path
          d="m282.478875 271.809421c0-14.891077-6.459506-26.847803-15.548845-31.46865-11.670124 2.223452-20.638726 15.677604-20.638726 33.226992 0 15.764576 1.180973 28.738493 13.888693 33.200522 16.348738.589895 22.298878-16.358253 22.298878-34.958864z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m291.74555 263.630295s-3.188249 2.715031-4.94273.797871c0 0-4.305079-34.512661-9.723216-34.671479l-18.654088-.158818s-2.229888.956689-3.188249 5.112427l-12.073843 34.410563-66.085425.952908-5.048375-10.587866 54.683189.158818v-.022688c.2943-1.062568 9.43269-33.760166 15.571485-37.813806.208343-.141338.435768-.252118.67538-.32898 0 0 22.796925-3.025105 30.290254-.960471 0 0 7.810267 1.758342 9.723216 4.159519.25657.268478 3.214661 3.607437 4.131518 13.234832z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m291.74555 264.269348s-3.188249 2.715031-4.94273.797871c0 0-4.305079-34.512661-9.723216-34.671479l-18.654088-.158818s-2.229888.95669-3.188249 5.112427l-12.073843 34.410564-66.085425.952907-5.048375-10.587865 54.683189.158818v-.022689c.2943-1.062568 9.43269-33.760166 15.571485-37.813806.208343-.141338.435768-.252118.67538-.32898 0 0 22.796925-3.025104 30.290254-.960471 0 0 7.810267 1.758342 9.723216 4.159519v.018907c.25657.268478 3.214661 3.607437 4.131518 13.234832z"
          fill="#dadff6"
          fillRule="nonzero"
        />
        <path
          d="m291.74555 264.269348s-3.188249 2.715031-4.94273.797871c0 0-4.305079-34.512661-9.723216-34.671479l-18.654088-.158818s-2.229888.95669-3.188249 5.112427l-12.073843 34.410564-66.085425.952907-5.048375-10.587865 54.683189.158818v-.022689c.2943-1.062568 9.43269-33.760166 15.571485-37.813806.208343-.141338.435768-.252118.67538-.32898 0 0 22.796925-3.025104 30.290254-.960471 0 0 7.810267 1.758342 9.723216 4.159519v.018907c.25657.268478 3.214661 3.607437 4.131518 13.234832z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m251.252899 226.56142c-1.596011 3.025105-15.303596 40.422959-15.303596 40.422959l-9.247809-6.71195v-.022689c.2943-1.062568 9.43269-33.794198 15.57903-37.813806 3.999461.665523 10.055248 2.064634 8.972375 4.125486z"
          fill="#dadff6"
          fillRule="nonzero"
        />
        <path
          d="m233.398704 209.465798-7.493329 24.601663-39.058882-1.134414.316938 3.675502s30.610965 4.473373 43.6809-1.599524l7.017922-22.472745 61.640741.317635-11.741812-2.76797z"
          fill="#dadff6"
          fillRule="nonzero"
        />
        <path
          d="m233.398704 209.465798-7.493329 24.601663-39.058882-1.134414.316938 3.675502s30.610965 4.473373 43.6809-1.599524l7.017922-22.472745 61.640741.317635-11.741812-2.76797z"
          fill="#fff"
          fillRule="nonzero"
          opacity=".2"
        />
        <path
          d="m50.2724636 248.236294s-20.9367983 10.546271-5.4219101 20.453488l4.1503836.956689s-15.1979499-10.966004 10.187305-21.410177z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m50.9101135 248.236294s-20.9367983 10.546271-5.4219101 20.453488l4.1503835.956689s-15.1979498-10.966004 10.187305-21.410177z"
          fill="#dce0ed"
          fillRule="nonzero"
        />
        <ellipse
          cx="267.511083"
          cy="274.494201"
          fill="#6c6f7a"
          fillRule="nonzero"
          rx="11.636166"
          ry="19.973253"
        />
        <ellipse
          cx="267.118683"
          cy="274.925278"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
          rx="8.459236"
          ry="16.184309"
        />
        <ellipse
          cx="267.118683"
          cy="274.286225"
          fill="#f0f0f4"
          fillRule="nonzero"
          rx="8.459236"
          ry="16.184309"
        />
        <ellipse
          cx="268.654325"
          cy="263.4261"
          fill="#636780"
          fillRule="nonzero"
          rx="1"
          ry="1.996569"
        />
        <ellipse
          cx="272.653786"
          cy="280.903641"
          fill="#636780"
          fillRule="nonzero"
          rx="1"
          ry="1.996569"
        />
        <ellipse
          cx="261.870335"
          cy="272.580822"
          fill="#636780"
          fillRule="nonzero"
          rx="1"
          ry="1.996569"
        />
        <ellipse
          cx="264.798242"
          cy="284.231256"
          fill="#636780"
          fillRule="nonzero"
          rx="1"
          ry="1.996569"
        />
        <ellipse
          cx="274.080008"
          cy="270.085111"
          fill="#636780"
          fillRule="nonzero"
          rx="1"
          ry="1.996569"
        />
        <ellipse
          cx="268.654325"
          cy="274.910153"
          fill="#636780"
          fillRule="nonzero"
          rx="2.927907"
          ry="4.741851"
        />
        <path
          d="m98.5225586 185.665789s35.3952254 1.278106 81.3060134 13.900355z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="m267.386572 123.564175s-1.920496.310073-.920631 2.851161 1.165881 3.853227 1.165881 3.853227 1.924268 1.002065 1.845034-2.314205c-.079235-3.316271-2.090284-4.390183-2.090284-4.390183z"
          fill="#dce0ed"
          fillRule="nonzero"
        />
        <path
          d="m173.244554 175.077923-.022638.030251c-.402465.503043-.663044 1.104999-.754615 1.743217-.309393 2.019257-.603693 6.156087 2.327987 5.471657 1.64932-.368723 3.162786-1.192614 4.369222-2.378488.670062-.712762 1.020368-1.669004.969681-2.646967.006719-.923522-.44784-1.789227-1.211157-2.306642l-1.090419-.627709c-.307649-.183293-.660976-.275098-1.018731-.264697l-1.886538.068065c-.66433.051441-1.275803.382583-1.682792.911313z"
          fill="#fec2be"
          fillRule="nonzero"
        />
        <path
          d="m194.434149 140.47829-5.633203 28.050282-3.988141 8.440041 2.641153 4.915795 5.848268-13.802039s6.414229-20.230386 6.414229-20.797594c0-.567207-5.282306-6.806485-5.282306-6.806485z"
          fill="#dadff6"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};
